/**
 * ===============================================================
 *  Ks-Bridge - Javascript Library
 *
 *  Copyright (c) 2018
 *  JasonFang and other contributors in KuaiShou.
 *
 *  ks-bridge.2.0.3.js 2.0.3 build at Tue Dec 15 2020 11:42:39 GMT+0800 (GMT+08:00) .
 *
 * ===============================================================
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ksBridge"] = factory();
	else
		root["ksBridge"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["g"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["k"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["i"] = isFile;
/* harmony export (immutable) */ __webpack_exports__["h"] = isBlob;
/* harmony export (immutable) */ __webpack_exports__["l"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["f"] = isAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignOptions;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateUUCallbackFunction;
/* harmony export (immutable) */ __webpack_exports__["c"] = generateHandlerFunction;
/* harmony export (immutable) */ __webpack_exports__["m"] = transformFuncToURL;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUrlParam;
/* harmony export (immutable) */ __webpack_exports__["b"] = compareVersion;
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var toStr = Object.prototype.toString;

var origin = function origin(o) {
  return o;
};

function isFunction(fn) {
  return typeof fn === 'function';
}
function isArray(arr) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(arr);
  }

  return toStr.call(arr) === '[object Array]';
}
function isObject(val) {
  return val !== null && _typeof(val) === 'object';
}
function isFile(val) {
  return toStr.call(val) === '[object File]';
}
function isBlob(val) {
  return toStr.call(val) === '[object Blob]';
}
function isUndefined(val) {
  return typeof val === 'undefined';
}
function isAbsoluteUrl(url) {
  return /^(https?)/.test(url);
}
function assignOptions() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extra = arguments.length > 1 ? arguments[1] : undefined;
  Object.keys(extra).forEach(function (key) {
    // 因为有的桥传的值就是 false，所以单独检查下，过滤掉值是 undefined，空字符串等
    if (extra[key] || extra[key] === false) {
      target[key] = extra[key];
    }
  });
  return target;
}
/**
 *
 * 生成唯一的id
 * @export
 * @returns
 */

function generateUUID() {
  var rc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  var pattern = rc ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' : 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}
/**
 *
 * 生成临时唯一的方法挂接到window上，给客户端回调用
 * @name generateUUCallbackFunction
 * @private
 * @param {function} callback 回调函数，客户端方法执行完后会执行该方法
 * @param {boolean} notDelete 是否删除当前回调，留在当前页面的内存中
 * @param {function} 返回参数处理函数 对 native 返回的参数进行预处理
 * @returns
 */


function generateUUCallbackFunction(bridgeName, callback, notDelete) {
  var resHandle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : origin;
  var name = "kwai_".concat(bridgeName, "_bridge_callback_") + generateUUID(false);

  window[name] = function (data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.warn(e); // eslint-disable-line
      }
    }

    callback && callback.call(window, resHandle(data));

    if (!notDelete) {
      delete window[name];
    }
  };

  return name;
} // 处理事件相关的 api 的 handler 回调

var handlerCbMap = {};
function generateHandlerFunction(bridgeName, callback) {
  var handlerName = '';
  var cb = null;
  Object.keys(handlerCbMap).some(function (cbName) {
    var handlerCb = handlerCbMap[cbName];

    if (handlerCb === callback) {
      cb = handlerCb;
      handlerName = cbName;
      return true;
    }
  }); // 当传递的 handler 回调之前已经挂载过，就不再重新挂载，重新生成 handler 回调名

  if (cb !== callback && callback) {
    var name = generateUUCallbackFunction(bridgeName, callback, true);
    handlerCbMap[name] = callback;
    handlerName = name;
  }

  return handlerName;
} // 用于 showDialog 相关 api 中，将回调转化成接口需要的 URL

function transformFuncToURL(bridgeName, btn) {
  var tmpBtn = btn;

  if (btn && isArray(btn.actions)) {
    tmpBtn.actions = btn.actions.map(function (action) {
      if (action && action.url && isFunction(action.url)) {
        action.url = generateUUCallbackFunction(bridgeName, action.url, true);
      }

      return action;
    });
  }

  return tmpBtn;
}
/**
 * 根据字符串的特点获取字符串中某个字段值，可以用于获取url的参数，cookie的参数
 * @name getValueByNameAccordToSplit
 * @private
 * @param {any} str 目标字符串
 * @param {any} name 获得的字符串名字
 * @param {string} [spliter='&']  分隔符
 * @returns
 */

function getValueByNameAccordToSpliter(str, name) {
  var spliter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '&';
  var arr = str.substr(1).split(spliter);

  if (!arr.length) {
    return null;
  }

  for (var i = 0; i < arr.length; i++) {
    var indexOfEqual = arr[i].indexOf('=');

    if (indexOfEqual === -1 && arr[i] === name) {
      return null;
    }

    if (arr[i].substr(0, indexOfEqual) === name) {
      return arr[i].substr(indexOfEqual + 1, arr[i].length);
    }
  }

  return null;
}
/**
 * 从url的search区域获取某个参数的值
 * @name getUrlParam
 * @private
 * @param {any} name
 * @returns
 */


function getUrlParam(name) {
  // array split is more faster then regexp even the code length is much more then the latter;
  // https://jsperf.com/regexp-vs-array-to-get-url-param1
  return decodeURIComponent(getValueByNameAccordToSpliter(window.location.search.substr(1), name, '&'));
}
/**
 * 比较版本号
 * @param  {string} source 比较源
 * @param  {string} target 比较目标
 * @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
 */

function compareVersion() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sourceArr = source.split('.');
  var targetArr = target.split('.');

  for (var i = 0; i < targetArr.length; i++) {
    if (sourceArr[i] !== targetArr[i]) {
      sourceArr[i] = isNaN(sourceArr[i]) ? 0 : sourceArr[i];
      targetArr[i] = isNaN(targetArr[i]) ? 0 : targetArr[i];
      return sourceArr[i] - targetArr[i];
    }
  }

  return 0;
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(0);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;

var isPlainObject = function isPlainObject(obj) {
  if (!obj || toStr.call(obj) !== '[object Object]') {
    return false;
  }

  var hasOwnConstructor = hasOwn.call(obj, 'constructor'),
      hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');

  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }

  return true;
};
/**
 *
 * @private
 * @param {Object | Boolean} target
 * @param {Object} source1
 * @param {Object} source2
 * ...
 */


function extend() {
  var options,
      name,
      src,
      copy,
      copyIsArray,
      clone,
      target = arguments[0],
      i = 1,
      length = arguments.length,
      deep = false;

  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    i = 2;
  } else if (_typeof(target) !== 'object' && typeof target !== 'function' || target == null) {
    target = {};
  }

  for (; i < length; ++i) {
    options = arguments[i];

    if (options != null) {
      for (name in options) {
        if (options.hasOwnProperty(name)) {
          src = target[name];
          copy = options[name];

          if (target !== copy) {
            if (deep && copy && (isPlainObject(copy) || (copyIsArray = Object(__WEBPACK_IMPORTED_MODULE_0__index__["g" /* isArray */])(copy)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone = src && Object(__WEBPACK_IMPORTED_MODULE_0__index__["g" /* isArray */])(src) ? src : [];
              } else {
                clone = src && isPlainObject(src) ? src : {};
              }

              target[name] = extend(deep, clone, copy);
            } else if (typeof copy !== 'undefined') {
              target[name] = copy;
            }
          }
        }
      }
    }
  }

  return target;
}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@ks/yoda-js-sdk");

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__);
// 环境设备判断等

/**
 * sniff <br />
 * 使用场景：查看运行环境，设备，系统等信息
 * @property ksBridge.sniff
 * @category Base
 *
 * @description
 * | 字段 | 类型 | 说明 |
 * | :--: | :--: | :--: |
 * | browserDesc | String | 浏览器类型，例如 "uc" |
 * | deviceHeightAndWidth | Object | 例如 { dph: 1334, dpw: 750 } |
 * | iOSVersion | Number | iOS 系统版本，例如 11 |
 * | isAndroid | Bool | |
 * | isIOS | Bool | |
 * | isInApp | Bool | 快手主 APP，概念版，极速版，直播伴侣等 |
 * | isInAcFun | Bool | AcFun 客户端，ks-bridge 1.0.14 版本新增 |
 * | isInBaidu | Bool | 百度手机客户端 |
 * | isInWeChat | Bool | 微信 |
 * | isInEnterpriseWeChat | Bool | 企业微信 |
 * | isInQQ | Bool | QQ |
 * | isInQQWebBrowser | Bool | QQ浏览器 |
 * | isInQzone | Bool | QQ空间 |
 * | isInTBS | Bool | 腾讯浏览服务(Tencent Browser Service) 简称TBS |
 * | isInUC | Bool | UC浏览器 |
 * | isInWeibo | Bool | 微博 |
 * | isInXiaomi | Bool | 小米 |
 * | isInKakaoTalk | Bool | KaKaoTalk |
 * | isInPinterest | Bool | Pinterest |
 * | isInZalo | Bool | Zalo |
 * | supportUniversalLink | Bool | |
 *
*/

var sniff = {};
var ua = navigator && navigator.userAgent;
sniff.isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
sniff.isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

function getIOSVersion() {
  if (!sniff.isIOS) {
    return false;
  }

  var match = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);

  if (!match || match.length < 3) {
    return false;
  }

  var version = parseFloat(parseInt(match[1], 10) + 0.1 * match[2]);

  if (version > 0) {
    return version;
  }

  return false;
}

sniff.iOSVersion = getIOSVersion();

function getCookie(objName) {
  // 获取指定名称的cookie的值
  var arrStr = document.cookie.split('; ');
  var temp;

  for (var i = 0; i < arrStr.length; i++) {
    temp = arrStr[i].split('=');

    if (temp[0] == objName) {
      return unescape(temp[1] || '');
    }
  }

  return '';
}

sniff.isInYoda = __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda;
sniff.isInKwai = / (Kwai|Kwai_Lite|Kwai_Pro|ksthanos|ksNebula|livemate|kswv)\//i.test(ua) || getCookie('appver').length > 0; // isInApp 代替 isInKwai，后者表义不再合适，需要逐渐被废弃

sniff.isInApp = sniff.isInKwai;
sniff.isInKuaishou = / Kwai\//i.test(ua);
sniff.isInNebula = / ksNebula\//i.test(ua);
sniff.isInThanos = / ksthanos\//i.test(ua);
sniff.isInAcFun = /ACVideoCore/i.test(ua);
sniff.isInWeChat = /MicroMessenger/i.test(ua);
sniff.isInEnterpriseWeChat = / wxwork\//i.test(ua);
sniff.isInWeibo = /Weibo/i.test(ua);
sniff.isInQQ = / QQ\//i.test(ua);
sniff.isInQzone = /Qzone\//i.test(ua); // 腾讯浏览服务(Tencent Browser Service) 简称TBS

sniff.isInTBS = / TBS\//i.test(ua);
sniff.isInQQWebBrowser = /MQQBrowser/i.test(ua) && !sniff.isInWeChat && !sniff.isInQQ && !sniff.isInQzone && !sniff.isInTBS; // 百度手机客户端

sniff.isInBaidu = / baiduboxapp\//i.test(ua); // UC浏览器

sniff.isInUC = / UCBrowser\//i.test(ua);
sniff.isInXiaomi = / XiaoMi\//i.test(ua); // KaKaoTalk

sniff.isInKakaoTalk = /KAKAOTALK/i.test(ua); // Pinterest

sniff.isInPinterest = /Pinterest\//i.test(ua); // Zalo

sniff.isInZalo = /Zalo/i.test(ua);
sniff.supportUniversalLink = sniff.iOSVersion >= 9;

function getBrowserDesc() {
  if (sniff.isInQQ) {
    return 'qq';
  }

  if (sniff.isInWeChat) {
    return 'wechat';
  }

  if (sniff.isInQzone) {
    return 'qzone';
  }

  if (sniff.isInWeibo) {
    return 'weibo';
  }

  if (sniff.isInBaidu) {
    return 'baidu';
  }

  if (sniff.isInUC) {
    return 'uc';
  }

  if (sniff.isIOS) {
    return 'ios';
  }

  if (sniff.isAndroid) {
    return 'android';
  }

  return '';
}

sniff.browserDesc = getBrowserDesc();

function getDeviceHeightAndWidth() {
  var result = {
    dph: window && window.screen && window.screen.availHeight || 1,
    dpw: window && window.screen && window.screen.availWidth || 1
  };

  if (window.devicePixelRatio !== undefined) {
    result.dph *= window.devicePixelRatio;
    result.dpw *= window.devicePixelRatio;
  }

  return result;
}

sniff.deviceHeightAndWidth = getDeviceHeightAndWidth();
/* harmony default export */ __webpack_exports__["a"] = (sniff);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setUpFunction;
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
// 普通 api 挂载逻辑


var fns = {};

var NOOP = function NOOP() {};

var origin = function origin(o) {
  return o;
}; // 在内存中构建一个 map，key 对应前端定义的 api，val 对应一个函数（函数主体是对客户端挂载的桥的封装）


function setUpFunction(key, api, nameSpace) {
  var _this = this;

  var conf = this.conf;
  var supportPromise = conf.supportPromise;
  var bridgeName = api.key || key;
  fns[key] = nameSpace ? fns[key] || {} : null;
  var optHandle = api.optHandle || origin;

  var func = function func(options) {
    var promiseChain = null;
    var opt = optHandle(options);
    var success = opt.success,
        fail = opt.fail,
        complete = opt.complete;

    if (supportPromise && opt && !opt.notPromise && !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(success) && !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(fail) && !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(complete)) {
      promiseChain = new Promise(function (resolve, reject) {
        opt.success = function (ret) {
          Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(success) && success(ret);
          Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(resolve) && resolve(ret);
        };

        opt.fail = function (err) {
          Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(fail) && fail(err);
          Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(reject) && reject(err);
        };
      });
    } else {
      opt.success = opt.success || NOOP;
      opt.fail = opt.fail || NOOP;
    }

    __WEBPACK_IMPORTED_MODULE_0__bridge__["b" /* invoke */].call(_this, bridgeName, api, opt);
    conf.debug && alert("[Ks-Bridge] Key => ".concat(key, ", BridgeName => ").concat(bridgeName, ", options => ").concat(JSON.stringify(opt)));
    return promiseChain;
  };

  if (nameSpace) {
    fns[key][nameSpace] = func;
  } else {
    fns[key] = func;
  }
} // 在前端全局生成 ksBridge 对象，key 对应定义的 api，val 是一个函数（主体是对 setUpFunction 函数生成的 map 中的函数的一次封装调用）

function register(key, nameSpace) {
  var _this2 = this;

  var process = function process(opt) {
    var fn = nameSpace ? fns[key][nameSpace] : fns[key];

    if (fn) {
      try {
        return fn.call(_this2, opt);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    } else {
      // TODO: 处理 api 不存在的情况
      opt && opt.callback && opt.callback(JSON.stringify({
        result: _this2.conf.notSupportErrorCode,
        error_msg: "".concat(key, " not support")
      }));
      _this2.conf.debug && alert("[Ks-Bridge] \"".concat(key, "\" not support!"));
    }
  };

  return function () {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return process(option);
  };
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCallback;
/* harmony export (immutable) */ __webpack_exports__["b"] = invoke;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ready__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_extend__ = __webpack_require__(1);
// jsbridge





var NOOP = function NOOP() {};

var origin = function origin(o) {
  return o;
};

var SKIP_PARAM_OPTION_SELF = '__self__';
function getCallback() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var successCb = options.success;
  var failCb = options.fail;
  var completeCb = options.complete;
  delete options.success;
  delete options.fail;
  delete options.complete;
  return function (data) {
    if (!data || data && typeof data === 'boolean') {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(successCb) && successCb();
    } else if (+data.result === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(successCb) && successCb(data);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(failCb) && failCb(data);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(completeCb) && completeCb(data);
  };
} // 调用 native api

function invoke(bridgeName, api, options) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_2__ready__["b" /* ready */].call(this, function () {
    invokeBridge.call(_this, bridgeName, api, options);
  });
}

function invokeBridge(bridgeName, api, options) {
  var yodaBridge = api.yodaBridge,
      _api$resHandle = api.resHandle,
      resHandle = _api$resHandle === void 0 ? origin : _api$resHandle;
  bridgeName = __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda && yodaBridge && yodaBridge.bridge || bridgeName;
  var namespace = this.conf.name || 'Kwai';
  var notDelete = !!options.notDelete;
  var _this$conf = this.conf,
      skipOptionsParam = _this$conf.skipOptionsParam,
      notSupportErrorCode = _this$conf.notSupportErrorCode;
  var opts = {};
  opts = Object(__WEBPACK_IMPORTED_MODULE_3__utils_extend__["a" /* default */])(true, opts, options);
  var skipParamSelf = opts[SKIP_PARAM_OPTION_SELF];
  skipOptionsParam.forEach(function (param) {
    if (opts.hasOwnProperty(param)) {
      delete opts[param];
    }
  });
  var cb = getCallback.call(this, opts);

  if (cb) {
    var cbName = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* generateUUCallbackFunction */])(bridgeName, cb, notDelete, resHandle);
    opts.callback = cbName;
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda && (!window[namespace] || !window[namespace][bridgeName])) {
    // 当该方法不存在时, 直接回调
    handleError();
    return false;
  }

  try {
    if (skipParamSelf === false) {
      callNative.call(this, bridgeName, null);
    } else if (__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda && yodaBridge) {
      // 针对一些特殊 bridge 需要调 yoda 公共的桥
      callYodaBridge.call(this, yodaBridge, opts);
    } else {
      callNative.call(this, bridgeName, opts);
    }
  } catch (e) {
    // 发生异常, 直接回调
    handleError();
    setTimeout(function () {
      e.message += " (from window.".concat(namespace, ".").concat(bridgeName, ")"); // 异步上报错误 不阻断当前代码

      throw e;
    });
    return false;
  }

  function callYodaBridge(yodaBridge, opts) {
    var namespace = yodaBridge.namespace,
        bridge = yodaBridge.bridge;
    var type = opts.type,
        handler = opts.handler,
        callback = opts.callback;
    var handlerFn = window[handler] || NOOP;
    var callbackFn = window[callback] || NOOP;
    var bridgeFn = __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a[namespace] && __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a[namespace][bridge];

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(bridgeFn)) {
      // 为方便接入H5秒开方案
      // 在 yoda webview 下对 addEventListener、removeEventListener 进行特殊适配
      if (bridge === 'addEventListener' || bridge === 'removeEventListener') {
        bridgeFn(type, handlerFn, callbackFn);
      } else {
        bridgeFn(opts, callbackFn);
      }
    }
  }

  function callNative(bridgeName, params) {
    var _this$conf2 = this.conf,
        name = _this$conf2.name,
        debug = _this$conf2.debug;
    var namespace = name || 'Kwai';

    if (__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda) {
      var _yodaBridge = __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a[namespace] && __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a[namespace][bridgeName];

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* isFunction */])(_yodaBridge)) {
        __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a[namespace][bridgeName](params, function () {});
        debug && alert("[Ks-Bridge] namespace => ".concat(namespace, " BridgeName => ").concat(bridgeName, " params => ").concat(params));
      } else {
        // 当该方法不存在时, 直接回调
        handleError();
        debug && alert("[Ks-Bridge] yoda.".concat(namespace, ".").concat(bridgeName, " \u4E0D\u5B58\u5728"));
      }
    } else {
      var strParam;

      try {
        strParam = JSON.stringify(params);
      } catch (e) {
        e.message += ' in JSON.stringify';
        throw e;
      }

      if (params && strParam) {
        window[namespace][bridgeName](strParam);
      } else {
        window[namespace][bridgeName]();
      }
    }
  }

  function handleError() {
    var language = window.navigator && (window.navigator.languages || window.navigator.language) || [];
    var errorMsg = language.length && language.indexOf('zh') === -1 && language.indexOf('zh-CN') === -1 ? 'Error occurred, please upgrade your app' : '出错啦, 请升级客户端至最新版本';
    opts.callback && window[opts.callback] && window[opts.callback](JSON.stringify({
      result: notSupportErrorCode,
      error_msg: errorMsg
    }));
  }

  return true;
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ready;
/* harmony export (immutable) */ __webpack_exports__["a"] = bridgeReadyCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ks_yoda_js_sdk__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ks_yoda_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ks_yoda_js_sdk__);
// 桥 ready 检测

 // ready之前的缓冲队列

var queue = [];
var times = 0;
var self = null;
var timeId = null;
var interval = 100;
function ready(listener) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* isFunction */])(listener)) {
    if (__WEBPACK_IMPORTED_MODULE_1__ks_yoda_js_sdk___default.a.isInYoda) {
      __WEBPACK_IMPORTED_MODULE_1__ks_yoda_js_sdk___default.a.ready(function () {
        listener();
      });
    } else {
      if (this.isReady) {
        listener();
      } else {
        queue.push(listener);
      }
    }
  }
} // 1 探测

function bridgeReadyCheck() {
  if (!__WEBPACK_IMPORTED_MODULE_1__ks_yoda_js_sdk___default.a.isInYoda) {
    self = this;
    var nameSpace = self.conf.name;
    var checkReadyBridge = self.conf.checkReadyBridge;
    var cbName = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* generateUUCallbackFunction */])(checkReadyBridge, bridgeReadyCb, false);

    try {
      window[nameSpace][checkReadyBridge]("{\"callback\":\"".concat(cbName, "\"}"));
    } catch (e) {
      bridgeReadyCb();
    }
  }
} // 2 探测结果, 可能继续探测 或 完成

function bridgeReadyCb(arg) {
  if (arg) {
    onReady();
  } else {
    times++;

    if (times < self.conf.defaultPollingTimes) {
      clearTimeout(timeId);
      timeId = setTimeout(function () {
        bridgeReadyCheck.call(self);
      }, interval);
    } else {
      onReady();
    }
  }
} // 3 探测结束


function onReady() {
  timeId = null;
  self.isReady = true; // 执行之前队列

  for (var i = 0; i < queue.length; i++) {
    var fn = queue[i];
    fn();
  }

  queue = [];
  times = 0;
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stringify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(0);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// https://github.com/substack/json-stable-stringify/blob/master/index.js
// 由于不想依赖 jsonify，直接 copy 了一份主体代码

function stringify(obj, opts) {
  if (!opts) {
    opts = {};
  }

  if (typeof opts === 'function') {
    opts = {
      cmp: opts
    };
  }

  var space = opts.space || '';

  if (typeof space === 'number') {
    space = Array(space + 1).join(' ');
  }

  var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;

  var replacer = opts.replacer || function (key, value) {
    return value;
  };

  var cmp = opts.cmp && function (f) {
    return function (node) {
      return function (a, b) {
        var aobj = {
          key: a,
          value: node[a]
        };
        var bobj = {
          key: b,
          value: node[b]
        };
        return f(aobj, bobj);
      };
    };
  }(opts.cmp);

  var seen = [];
  return function _stringify(parent, key, node, level) {
    var indent = space ? '\n' + new Array(level + 1).join(space) : '';
    var colonSeparator = space ? ': ' : ':';

    if (node && node.toJSON && typeof node.toJSON === 'function') {
      node = node.toJSON();
    }

    node = replacer.call(parent, key, node);

    if (node === undefined) {
      return '';
    }

    if (_typeof(node) !== 'object' || node === null) {
      return JSON.stringify(node);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__index__["g" /* isArray */])(node)) {
      var _out = [];

      for (var i = 0; i < node.length; i++) {
        var item = stringify(node, i, node[i], level + 1) || JSON.stringify(null);

        _out.push(indent + space + item);
      }

      return '[' + _out.join(',') + indent + ']';
    }

    if (seen.indexOf(node) !== -1) {
      if (cycles) {
        return JSON.stringify('__cycle__');
      }

      throw new TypeError('Converting circular structure to JSON');
    } else {
      seen.push(node);
    }

    var keys = Object.keys(node).sort(cmp && cmp(node));
    var out = [];

    for (var _i = 0; _i < keys.length; _i++) {
      var _key = keys[_i];

      var value = _stringify(node, _key, node[_key], level + 1);

      if (!value) {
        continue;
      }

      var keyValue = JSON.stringify(_key) + colonSeparator + value;
      out.push(indent + space + keyValue);
    }

    seen.splice(seen.indexOf(node), 1);
    return '{' + out.join(',') + indent + '}';
  }({
    '': obj
  }, '', obj, 0);
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(10);

var ksBridge = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */]();
ksBridge.config();

if (window !== undefined) {
  window.ksBridge = ksBridge;
}

/* harmony default export */ __webpack_exports__["default"] = (ksBridge);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KsBridge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_sniff__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_init__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_bridge__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_request__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_logger__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_md5__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_md5__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// KsBridge










 // 表示options自己，就是不要传参的意思

var SKIP_PARAM_OPTION_SELF = '__self__';
var DEFAULT_CONFIG = {
  version: "2.0.3-rc.1" || '0.0.0',
  name: 'Kwai',
  notSupportErrorCode: 118003,
  appType: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* getUrlParam */])('appType'),
  // 默认不需要传给客户端的参数，只给前端使用的
  // 例如是否强制fallback，回调函数是否常驻内存，
  // 以及是否有些桥不让传参（这是早期约定的问题，居然还有这种约定。。。。变参。。。。。，android某些bridge不让传参）
  skipOptionsParam: ['notDelete', SKIP_PARAM_OPTION_SELF],
  supportPromise: false,
  hasNameSpace: false,
  // 检查桥是否 ready 时默认的轮询次数
  defaultPollingTimes: 10,
  checkReadyBridge: 'gete2',
  // radar项目ID
  radarProjectId: 'd113bf5b9c',
  debug: false
};
var PRELOAD_REQUEST_EVENT_MAP = {};
var isListenDataFetchChange = false;

function checkRunEnv() {
  var ua = navigator && navigator.userAgent; // 直播伴侣

  if (/ livemate\//.test(ua)) {
    DEFAULT_CONFIG.name = 'livemate';
  }
}

var KsBridge = /*#__PURE__*/function () {
  function KsBridge() {
    _classCallCheck(this, KsBridge);

    checkRunEnv();
    this.conf = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, {}, DEFAULT_CONFIG);
    this.isInit = false;
    this.isReady = false;
    this.sniff = __WEBPACK_IMPORTED_MODULE_1__lib_sniff__["a" /* default */];
    this.plugins = [];
    this.generateUUCallbackFunction = __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* generateUUCallbackFunction */];
    this.yodaApiMap = {};
    this.yoda = __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a;
  }
  /**
   * 配置 KsBridge <br />
   * 使用场景：对 KsBridge 默认配置项进行覆盖。<br/>
   * 对接人： fangchangquan
   * @method ksBridge.config
   * @category Base
   * @version >=1.0.0
   * @example ./config.demo
   * @demo base/config
   * @description
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | debug | Bool | 是否支持调试模式 | X | 常用参数，默认false |
   * | name | String | 客户端在 window 上挂载的变量名，如果是其他客户端，例如直播伴侣，可以指定 'livemate' | X | 默认是 'Kwai' |
   * | supportPromise | Bool | 是否开启 promise，取代传统的回调方式，部分 bridge 不支持，具体使用细节请查看下方说明，从 1.0.13 版本开始支持 | X | 默认是 false |
   * | checkReadyBridge | string | bridge 名，用于 ks-bridge 内部检查当前桥的注入是否 ready，如果需要修改，请注意不要使用会引起 UI 变化的 bridge | X |默认是 gete2 |
   * | logSampleRate | number | bridge 调用打点日志上报采样率 | X | v2.0.2 已下线，不再上报日志；v2.0.0、v2.0.1 版本默认为 0.5，即 50%；v1.x 版本（除1.0.17）默认为 1，即 100%；v1.0.17 版默认值为 0.01（春节版本） |
   * | logDelay | number | bridge 调用打点日志上报延迟时间设置 | X| v2.0.2 已下线，不再上报日志；v2.0.0、v2.0.1 版本默认 2000，即2s |
    *
   * **说明**：
   * + 不是所有 bridge 均支持 promise 方式调用，只支持“可以被 Promise 化”的 bridge，可以理解为”回调期望被调用一次且仅一次“的 bridge
   * + 不支持 promise 的 bridge：同步方法（没有回调）；回调期望被调用多次的异步方法，如 postVideo bridge 的回调会持续触发，直至上传完成
   * + 使用示例请参考 getDeviceInfo 和 commonShare bridge 的示例 demo
   *
   * 不支持 promise 的 api：
   * + 同步方法：startGatewayWithdraw、startPlayLongVideo、collapseKeyboard、setPageTitle、setStatusBarStyle、showToast、exitWebView、loadUrlOnNewPage、popBack、setMiddleSlideBack、setSlideBack、previewIntownVideo
   * + 多次回调的方法：download、postVideo、verifyThirdPartyLogin、setPhysicalBackButton、setTopLeftBtn、setTopLeftSecondBtn、
   * setTopRightBtn、setTopRightSecondBtn、showAlertDialog、showConfirmDialog、showDialog、emit、on、off、reuploadIntownVideo、uploadIntownVideo、downloadThirdPartyAPP
   * + 如有遗漏，欢迎补充
   *
   */


  _createClass(KsBridge, [{
    key: "config",
    value: function config(conf) {
      var _this = this;

      if (!this.isInit || conf) {
        var config = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, {}, this.conf, conf) || {};
        this.conf = config;
        this.isInit = true;
        config.debug && alert("\u8C03\u7528 config\uFF0C\u53C2\u6570\uFF1A".concat(JSON.stringify(conf)));
        this.plugins.forEach(function (plugin) {
          plugin.call(_this, config);
        });
        __WEBPACK_IMPORTED_MODULE_2__lib_init__["a" /* default */].call(this, config);

        if (__WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.isInYoda) {
          // 获取 bridge 列表，用于 isSupport
          __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.ready(function () {
            __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.tool.getApiList({}, function (_ref) {
              var result = _ref.result,
                  apiList = _ref.apiList;

              if (result === 1) {
                apiList.forEach(function (api) {
                  var namespace = api.namespace,
                      name = api.name;
                  _this.yodaApiMap[namespace] = _this.yodaApiMap[namespace] || [];

                  _this.yodaApiMap[namespace].push(name);
                });
              }
            });
          });
        }
      }
    } // 拓展插件

  }, {
    key: "plugin",
    value: function plugin(_plugin) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* isFunction */])(_plugin) && this.plugins.push(_plugin);
    } // 临时注册客户端 api，避免每加一个 api 都要发版

    /**
     * 通过register扩展接口<br />
     * 使用场景：临时向 KsBridge 上挂载一个 api，避免每新增一个 api，都需要 KsBridge 发版<br />
     * 对接人： fangchangquan
     * @method ksBridge.register
     * @category Base
     * @version >=1.0.0
     * @example ./register.demo
     * @demo base/register
     * @description
     * 
     * 调用参数：
     * 
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | name | String | 接口名称 | √ | 常用参数 |
     * | bridgeName | String | 对应native桥名字 | √ | 常用参数 |
     * | namespace | String | 命名空间 | x | 常用参数，默认无 |
     * | option | Object | native桥额外配置 | x | 默认值为 { notDelete: false } |
     * 
     * 注意事项：
     * **一定记得先注册再使用，否则会报undefined**
     */

  }, {
    key: "register",
    value: function register(name, bridgeName) {
      var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        notDelete: false
      };

      if (!name || !bridgeName) {
        console.error('参数name、bridgeName必传'); // eslint-disable-line

        return;
      }

      var api = {
        key: bridgeName
      }; // TODO: 这里实现总觉得不优雅，后续期望能有更好的实现方式

      api.optHandle = function (opt) {
        opt = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, opt, option);

        if (opt.onClick) {
          opt.onClick = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* generateUUCallbackFunction */])(name, opt.onClick, true);
        }

        if (opt.handler) {
          opt.handler = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* generateHandlerFunction */])(name, opt.handler, true);
        }

        return opt;
      };

      var self = this;
      this._apis = this._apis || {};
      __WEBPACK_IMPORTED_MODULE_3__lib_register__["b" /* setUpFunction */].call(this, name, api, namespace);

      if (namespace) {
        this[namespace] = this[namespace] || {};
        this._apis[namespace] = this._apis[namespace] || {};
        this._apis[namespace][name] = api;
        self = this[namespace];
      } else {
        this._apis[name] = api;
      }

      self[name] = __WEBPACK_IMPORTED_MODULE_3__lib_register__["a" /* register */].call(this, name, namespace);
    }
    /**
     * 检查是否支持指定JS接口<br />
     * 使用场景：在不确定当前客户端对API支持情况下检测，yoda 下检测不准，推荐使用 isSupportAsync<br />
     * 对接人： fangchangquan
     * @method ksBridge.isSupport
     * @category Base
     * @version >=1.0.0
     * @example ./isSupport.demo
     * @demo base/isSupport
     * @description
     *
     * 调用参数：
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | api | String | api 名字 | √ | - |
     * | namespace | String | api 命名空间，当通过 register 方法注册的 api 时指定了命名空间，检测时也要指定，其他情况不要传该值，参考示例3 | X | - |
     *
     * 返回参数：
     * 直接返回一个布尔值，true 表示支持，false 表示不支持
     */

  }, {
    key: "isSupport",
    value: function isSupport() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var res = false;

      if (!api) {
        this.conf.debug && alert('api 为必传参数');
      }

      var apis = this._apis && namespace ? this._apis[namespace] : this._apis;

      if (!apis || !apis[api]) {
        this.conf.debug && alert("\u8BF7\u68C0\u67E5 ".concat(api, " \u662F\u5426\u5C01\u88C5"));
        return res;
      }

      var bridgeName = apis[api].key || api;

      try {
        var name = this.conf.name || 'Kwai';

        if (__WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.isInYoda) {
          var apiList = this.yodaApiMap[name];
          res = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["g" /* isArray */])(apiList) && apiList.indexOf(bridgeName) > -1;
        } else {
          res = !!window[name][bridgeName];
        }
      } catch (e) {// nothing
      }

      return res;
    }
    /**
     * 检查是否支持指定JS接口<br />
     * 使用场景：在不确定当前客户端对API支持情况下检测，异步返回结果<br />
     * 注意：<font color=FF0000>isSupportAsync 传参格式与 isSupport 不同，具体参见示例</font><br />
     * 对接人： fangchangquan
     * @method ksBridge.isSupportAsync
     * @category Base
     * @version >=2.0.0
     * @example ./isSupportAsync.demo
     * @demo base/isSupportAsync
     * @description
     *
     * 调用参数：
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | api | String | api 名字 | √ | - |
     * | namespace | String | api 命名空间，当通过 register 方法注册的 api 时指定了命名空间，检测时也要指定，其他情况不要传该值，参考示例3 | X | - |
     *
     * 返回参数：
     * 
     * 返回值为一个布尔值，isSupportAsync 支持 promise，具体调用参照示例
     */

  }, {
    key: "isSupportAsync",
    value: function isSupportAsync(param) {
      var ns = this.conf.name || 'Kwai';
      var cb = __WEBPACK_IMPORTED_MODULE_4__lib_bridge__["a" /* getCallback */].call(this, param, ns, 'isSupportAsync');
      var _param$namespace = param.namespace,
          namespace = _param$namespace === void 0 ? '' : _param$namespace,
          _param$api = param.api,
          api = _param$api === void 0 ? '' : _param$api;

      if (!api) {
        this.conf.debug && alert('api 为必传参数');
      }

      var apis = this._apis && namespace ? this._apis[namespace] : this._apis;
      var bridgeName = apis && apis[api] && apis[api].key || api;
      var returnPromise;
      var res;

      if (__WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.isInYoda) {
        return __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.ready().then(function () {
          return __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.tool.canIUse({
            namespace: ns,
            name: bridgeName
          });
        }).then(function (ret) {
          res = !!(ret && ret.result === 1 && ret.canUse);
          returnPromise = new Promise(function (resolve) {
            return resolve(res);
          });
          cb(res);
          return returnPromise;
        });
      }

      res = !!(window[ns] && window[ns][bridgeName]);
      returnPromise = new Promise(function (resolve) {
        return resolve(res);
      });
      cb(res);
      return returnPromise;
    }
    /**
     * 接口请求<br />
     * 使用场景：接入接口预加载时使用<br />
     * 对接人： fangchangquan
     * @method ksBridge.request
     * @category Base
     * @version >=2.0.2
     * @example ./request.demo
     * @demo base/request
     * @description
     *
     * 调用参数：
     *
     * | 参数 | 类型 | 默认值 | 是否必填 | 说明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | url | string | - | √ | 请求地址 |
     * | method | string | POST | √ | 请求方法 |
     * | data | string | - | X | 请求的参数，一期仅支持 json string |
     * | headers	| Object | { 'content-type': 'application/json' } | X | 设置请求的 headers，其中 content-type 默认为 application/json |
     * | timeout | number | 30000 | X | 超时时间，单位为毫秒 |
     * | responseType | string | json | X | 响应的数据类型，一期仅支持 json、text |
     * | preloadType | string | - | X | 预加载请求类型 |
     * | forceFallback | boolean | false | X | 强制不走桥发请求 |
     * 
     * 返回参数：
     * 
     * | 参数 | 类型 | 说明 |
     * | :--: | :--: | :--: |
     * | result | number | bridge 调用返回 code，1 表示调用成功，其他值表示调用异常 |
     * | data | string/Object | 开发者服务器返回的数据 |
     * | statusCode | number | 开发者服务器返回的 HTTP 状态码 |
     * | headers | Object	 | 开发者服务器返回的 HTTP Response Header |
     * 
     * 需求设计[文档](https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=498181222)
     */

  }, {
    key: "request",
    value: function request() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$conf = this.conf,
          debug = _this$conf.debug,
          notSupportErrorCode = _this$conf.notSupportErrorCode,
          radarProjectId = _this$conf.radarProjectId;
      var callback = __WEBPACK_IMPORTED_MODULE_4__lib_bridge__["a" /* getCallback */].call(this, params);
      var PROXYTYPE_PRELOAD = 1;
      var PROXYTYPE_REQUEST = 2;
      var PROXYTYPE_PRELOAD_AND_REQUEST = 3;
      var ua = navigator.userAgent || '';

      var _ref2 = ua.match(/Yoda\/([\d+.*]+)/) || [],
          _ref3 = _slicedToArray(_ref2, 2),
          _ref3$ = _ref3[1],
          appVer = _ref3$ === void 0 ? '' : _ref3$;

      var defaultVer = '1.2.1';
      var _params$url = params.url,
          url = _params$url === void 0 ? '' : _params$url;

      if (!url) {
        callback({
          result: notSupportErrorCode,
          error_msg: '调用参数异常'
        });
        return;
      } // 当业务调用时传入相对路径地址，默认为其拼接上当前页面的 origin


      params.url = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* isAbsoluteUrl */])(url) ? url : location.origin + url;
      params.method = params.method || 'POST';
      params.proxyType = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["l" /* isUndefined */])(params.proxyType) && PROXYTYPE_PRELOAD_AND_REQUEST || params.proxyType;
      params.preloadType = params.preloadType || 'update';

      try {
        // 桥调用参数需要额外处理下，包括按字母排序后转成 json string
        // 因为生成 reqMd5 需要，所以提前处理下
        params.data = params.data && Object(__WEBPACK_IMPORTED_MODULE_7__utils_stringify__["a" /* default */])(params.data) || '';
      } catch (e) {
        params.data = '';
      }

      var reqMd5 = __WEBPACK_IMPORTED_MODULE_10_md5___default()(params.data + params.method + params.url);

      if (!PRELOAD_REQUEST_EVENT_MAP[reqMd5]) {
        PRELOAD_REQUEST_EVENT_MAP[reqMd5] = {
          callback: callback,
          startTime: new Date().getTime()
        };
      }

      var DATAFETCHCHANGE_EVENT = 'data-fetch-change';
      var logParam = {
        category: 'yoda_request',
        src: params.url,
        extra_info: JSON.stringify(params)
      };

      function h5Request(params) {
        var headers = params.headers,
            proxyType = params.proxyType,
            preloadType = params.preloadType;
        var reqParams = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, params, {
          headers: headers
        });
        var isUpdateData = (proxyType === PROXYTYPE_PRELOAD || proxyType === PROXYTYPE_PRELOAD_AND_REQUEST) && preloadType === 'offline-first';
        return Object(__WEBPACK_IMPORTED_MODULE_6__utils_request__["a" /* default */])(reqParams).then(function (res) {
          res.isUpdateData = isUpdateData;
          callback(res);
          return res;
        }).catch(function (err) {
          // eslint-disable-next-line
          debug && console.log(err);
          var res = {
            result: notSupportErrorCode,
            error_msg: 'h5 ajax请求异常',
            isUpdateData: isUpdateData
          };
          callback(res);
          return res;
        }).then(function (res) {
          var result = res.result,
              error_msg = res.error_msg;
          var eventType = [proxyType, preloadType];
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_logger__["a" /* sendEventLog */])(radarProjectId, _objectSpread(_objectSpread({}, logParam), {}, {
            name: 'yoda_request_h5',
            event_type: eventType.filter(function (v) {
              return !Object(__WEBPACK_IMPORTED_MODULE_5__utils__["l" /* isUndefined */])(v);
            }).join('_') || '',
            result_type: result,
            message: error_msg || ''
          }), PRELOAD_REQUEST_EVENT_MAP[reqMd5].startTime);
        });
      }

      if (__WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.isInYoda && !params.forceFallback) {
        __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.ready(function () {
          function eventHandler(ret) {
            var _ref4 = ret || {},
                result = _ref4.result,
                requestId = _ref4.requestId; // 当 js-sdk 外部已监听 data-fetch-change 事件，sdk 内部监听的事件回调逻辑直接跳过


            var listeners = __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a._eventListeners && __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a._eventListeners[DATAFETCHCHANGE_EVENT] || {};

            if (Object.keys(listeners).length > 1) {
              return;
            }

            if (result === 1) {
              if (requestId !== PRELOAD_REQUEST_EVENT_MAP[reqMd5].requestId) {
                return;
              }

              var _params = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, {}, params);

              _params.preloadType = 'offline-first';
              __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.network.request(_params, function (res) {
                var result = res.result,
                    headers = res.headers,
                    message = res.message;
                var responseType = headers && headers['yoda-response-type'];
                var fn = PRELOAD_REQUEST_EVENT_MAP[reqMd5] && PRELOAD_REQUEST_EVENT_MAP[reqMd5].callback; // request 桥调用日志

                Object(__WEBPACK_IMPORTED_MODULE_8__utils_logger__["a" /* sendEventLog */])(radarProjectId, _objectSpread(_objectSpread({}, logParam), {}, {
                  name: 'yoda_request',
                  event_type: '',
                  result_type: result,
                  message: message || '',
                  extra_info: JSON.stringify(_params)
                })); // request 桥预取结果日志

                var eventType = [_params.proxyType, _params.preloadType, responseType];
                Object(__WEBPACK_IMPORTED_MODULE_8__utils_logger__["a" /* sendEventLog */])(radarProjectId, _objectSpread(_objectSpread({}, logParam), {}, {
                  name: 'yoda_request_prefetch',
                  event_type: eventType.filter(function (v) {
                    return !Object(__WEBPACK_IMPORTED_MODULE_5__utils__["l" /* isUndefined */])(v);
                  }).join('_') || '',
                  result_type: result,
                  message: message || '',
                  extra_info: JSON.stringify(_params)
                }), PRELOAD_REQUEST_EVENT_MAP[reqMd5].startTime);

                if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* isFunction */])(fn)) {
                  // res.isUpdateData true表示第二次触发回调，更新数据
                  res.isUpdateData = true;
                  fn(res);
                  delete PRELOAD_REQUEST_EVENT_MAP[reqMd5];
                }

                if (!Object.keys(PRELOAD_REQUEST_EVENT_MAP).length) {
                  __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.event.removeEventListener(DATAFETCHCHANGE_EVENT, eventHandler);
                  isListenDataFetchChange = false;
                }
              });
            } else {
              h5Request(params);
            }
          }

          __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.tool.canIUse({
            namespace: 'network',
            name: 'request'
          }, function (_ref5) {
            var result = _ref5.result,
                canUse = _ref5.canUse;
            // ios 下 yoda sdk 低于 defaultVer 1.2.1 的客户端，当调用 ksBridge.request 传的 preloadType 参数不是 update/offline-first 时，强制走 h5 ajax请求
            var proxyType = params.proxyType,
                preloadType = params.preloadType;
            var isSupportForIOS = !(__WEBPACK_IMPORTED_MODULE_1__lib_sniff__["a" /* default */].isIOS && Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* compareVersion */])(appVer, defaultVer) < 0 && preloadType !== 'update' && preloadType !== 'offline-first');

            if (result === 1 && canUse && isSupportForIOS) {
              // eslint-disable-next-line
              debug && console.log('request 调用参数：', params);

              if (!isListenDataFetchChange) {
                isListenDataFetchChange = true;
                __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.event.addEventListener(DATAFETCHCHANGE_EVENT, eventHandler);
              }

              __WEBPACK_IMPORTED_MODULE_9__ks_yoda_js_sdk___default.a.network.request(params, function (res) {
                var result = res.result,
                    headers = res.headers,
                    message = res.message;
                var responseType = headers && headers['yoda-response-type']; // eslint-disable-next-line

                debug && console.log('request 桥回调参数：', res);

                if (result === 1) {
                  PRELOAD_REQUEST_EVENT_MAP[reqMd5].requestId = headers && headers['yoda-request-id'];
                  callback(res);
                } else {
                  // 当桥回调返回参数的 result 非 1 时 fallback 到 h5 发请求
                  h5Request(params);
                } // request 桥调用日志


                Object(__WEBPACK_IMPORTED_MODULE_8__utils_logger__["a" /* sendEventLog */])(radarProjectId, _objectSpread(_objectSpread({}, logParam), {}, {
                  name: 'yoda_request',
                  event_type: '',
                  result_type: result,
                  message: message || ''
                })); // request 桥调用结果日志

                var name = proxyType === PROXYTYPE_REQUEST ? 'yoda_request_online' : 'yoda_request_prefetch';
                var eventType = proxyType === PROXYTYPE_REQUEST ? [proxyType] : [proxyType, preloadType, responseType];
                Object(__WEBPACK_IMPORTED_MODULE_8__utils_logger__["a" /* sendEventLog */])(radarProjectId, _objectSpread(_objectSpread({}, logParam), {}, {
                  name: name,
                  event_type: eventType.filter(function (v) {
                    return !Object(__WEBPACK_IMPORTED_MODULE_5__utils__["l" /* isUndefined */])(v);
                  }).join('_') || '',
                  result_type: result,
                  message: message || ''
                }), PRELOAD_REQUEST_EVENT_MAP[reqMd5].startTime);
              });
            } else {
              // 当 request 不支持调用时 fallback 到 h5 发请求
              h5Request(params);
            }
          });
        });
      } else {
        // 非 yoda 环境或强行forceFallback设置时 fallback 到 h5 发请求
        h5Request(params);
      }
    }
  }]);

  return KsBridge;
}();



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__register__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ready__ = __webpack_require__(6);
// 初始化




function init() {
  var _this = this;

  this._apis = {};
  var hasNameSpace = this.conf.hasNameSpace;
  var self = this;
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */]).forEach(function (nameSpace) {
    // TODO: 需要确认下是否符合当时定的动态支持命名空间的预期
    var ns = hasNameSpace ? nameSpace : '';
    var apiList = __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */][nameSpace];
    _this._apis = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, _this._apis, apiList);
    _this._apis[nameSpace] = apiList;

    if (hasNameSpace) {
      _this[nameSpace] = _this[nameSpace] || {};
      self = _this[nameSpace];
    }

    Object.keys(apiList).forEach(function (key) {
      __WEBPACK_IMPORTED_MODULE_2__register__["b" /* setUpFunction */].call(_this, key, apiList[key], ns);
      var fn = __WEBPACK_IMPORTED_MODULE_2__register__["a" /* register */].call(_this, key, ns);
      self[key] = fn;
    });
  });
  __WEBPACK_IMPORTED_MODULE_3__ready__["a" /* bridgeReadyCheck */].call(this);
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__system__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__webview__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__intown__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__third__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__merchant__ = __webpack_require__(134);











/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__data__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__page__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__system__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__ui__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__webview__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__event__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__intown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__third__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__merchant__["a" /* default */]));

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__runSequencialTasks__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__verifyRealNameInfo__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectImage__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectAndUploadMedia__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__postVideo__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bindWithdrawType__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__injectCookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__verifySMSCode__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__socialShare__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fansTopPay__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__couponPay__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonShare__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__startGatewayPay__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__startPlayLongVideo__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__startAudioRecord__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__login__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__logout__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__deleteAccount__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__verifyThirdPartyLogin__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectCountryPhoneCode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__captureCertVideo__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__uploadCertVideo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__uploadContacts__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sendSMS__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__decryptContactsName__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__bindPhone__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__download__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__selectCity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__verifyLiveUser__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__publishWorks__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__verifyAccount__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__enterGroupChat__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__startGatewayWithdraw__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__saveImage__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__sendImFriendMessage__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__selectScreenshot__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__wechatLogin__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__authThirdPartyAccount__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__downloadProgress__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__installApk__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__iAPCurrency__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__share__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__businessAction__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__startDeposit__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__startKspayOrderPrepay__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__setPageFollowRefer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__authorizationStatusForCalendar__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__changeEventForCalendar__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__renderImage__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__requestFollowUserV2__ = __webpack_require__(63);



















































var component = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_50__requestFollowUserV2__["a" /* default */], __WEBPACK_IMPORTED_MODULE_49__renderImage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_48__changeEventForCalendar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_47__authorizationStatusForCalendar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_46__setPageFollowRefer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_45__startKspayOrderPrepay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_44__startDeposit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_43__businessAction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__iAPCurrency__["a" /* default */], __WEBPACK_IMPORTED_MODULE_40__installApk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__downloadProgress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38__authThirdPartyAccount__["a" /* default */], __WEBPACK_IMPORTED_MODULE_37__wechatLogin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_36__selectScreenshot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_35__sendImFriendMessage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_34__saveImage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__startGatewayWithdraw__["a" /* default */], __WEBPACK_IMPORTED_MODULE_32__enterGroupChat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__verifyThirdPartyLogin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__logout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__deleteAccount__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__selectCountryPhoneCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__captureCertVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__uploadCertVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__verifyRealNameInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__selectImage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__selectAndUploadMedia__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__postVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__bindPhone__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__uploadContacts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__verifyAccount__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__sendSMS__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__decryptContactsName__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__socialShare__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__commonShare__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__bindWithdrawType__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__download__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__injectCookie__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__fansTopPay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__couponPay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__startGatewayPay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__startPlayLongVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__startAudioRecord__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__verifySMSCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__runSequencialTasks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__selectCity__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__verifyLiveUser__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__publishWorks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_42__share__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  component: component
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 执行任务队列<br />
   * 对应native接口：runSequencialTasks<br/>
   * 支持版本：客户端2017.11.28版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.runSequencialTasks
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/runSequencialTasks.demo
   * @demo component/runSequencialTasks
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | tasks | Array | 任务数组 | √ | task目前只支持示例代码中的几种类型，可以为一个，也可以为多个，调用顺序严格按照tasks数组里的顺序执行，数组元素：{ taskName: 'bindPhone', info: '绑定手机号，确认你的直播账号安全' } |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // result 四种结果：1: 成功、0: 用户取消、其他：出错、100: 无法识别task
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  runSequencialTasks: true
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 调起腾讯实名认证服务(直播认证)<br />
   * 对应native接口：verifyRealNameInfo<br/>
   * 支持版本：客户端17年6月版本<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.verifyRealNameInfo
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/verifyRealNameInfo.demo
   * @demo component/verifyRealNameInfo
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | data | Object | 腾讯实名认证SDK所需字段 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     //result 不为1时返回错误信息(国际化)
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  verifyRealNameInfo: true
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 从系统相册选择图片<br />
   * 对应native接口：selectImage<br/>
   * 注意：从18年8月，开始支持上传多张，并多次触发回调<br />
   * 支持版本：客户端2017.6月版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.selectImage
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/selectImage.demo
   * @demo component/selectImage
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | count | Number | 选择图片数量 | X |  |
   * | sourceType | Array | 可以指定来源是相册还是相机，默认二者都有 | X | 默认 ['album', 'camera'] |
   * | maxFileSize | Number | 字节单位 | X | 不存在则为不限制，原图超过该值时自动压缩 |
   * | maxWidth | Number | 像素单位 | X | 不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大 |
   * | maxHeight | Number | 像素单位 | X | 不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大 |
   * | title | String | 设置 naviBar 的 title 文案 | X | Android 6.4.2，ios 6.4.1 版本开始支持 |
   * | confirmTitle | String | 完成按钮文案 | X | Android 6.4.2，ios 6.4.1 版本开始支持 |
   * | minFileSize | Number | 最小文件大小，不传不限制 | X | 预计 8.1.10 支持 |
   * | minSizeAlert | string | 没达到最小size时，toast文案，不传不弹toast | X | 预计 8.1.10 支持 |
   * | minWidth | Number | 最小图片/视频宽度，不传不限制 | X | 预计 8.1.10 支持 |
   * | minHeight | Number | 最小图片/视频高度，不传不限制 | X | 预计 8.1.10 支持 |
   * | minHeightWidthAlert | String | 没达到最小宽度或高度时，toast文案，不传不弹toast | X | 预计 8.1.10 支持 |
   * | selectedList | Array<string> | 进相册时预先选中的数据，给原始图片路径的列表 | X | 预计 8.1.10 支持 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',//result 不为1时返回错误信息(国际化)
   *     data:[{
   *         // originFilePath 新增字段，预计 8.1.10 支持
   *         originFilePath: '', // 原始图片路径
   *         base64: 'xxxxx',
   *         width: 1024, // 单位px
   *         height: 768,
   *         fileType: 'png'
   *     }, {...}, {...}]
   * }
   * ```
   */
  selectImage: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 从相册选择媒体资源上传<br />
   * 对应native接口：selectAndUploadMedia<br/>
   * 注意：需要登录，一次只支持上传1个资源，目前快接单里有使用<br/>
   * 支持版本：客户端2017.6月版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.selectAndUploadMedia
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/selectAndUploadMedia.demo
   * @demo component/selectAndUploadMedia
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | sourceType | Array | 可以指定来源是相册还是相机，或二者都有 | √ | 默认 ['album', 'camera'] |
   * | uploadToken | String | 用上传key，客户端透传 | √ | - |
   * | mediaType | String | image 为图片 video 为视频 | √ | - |
   * | fileType | String | mediaType = image 只支持 jpeg/png，mediaType = video 只支持 mp4 | √ | - |
   * | maxFileSize | Number | 字节单位，不存在则为不限制，超过该值时自动压缩(视频暂不能完美支持支持)| √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: ''
   * }
   * ```
   */
  selectAndUploadMedia: true
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 视频拍摄和发布<br />
   * 对应native接口：postVideo<br/>
   * 注意：回调多次，前端可根据 progress 显示上传进度；从 ks-bridge 1.0.11 版本开始，returnToWeb 参数默认为 true<br/>
   * 对接人： fangchangquan
   * @method ksBridge.postVideo
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/postVideo.demo
   * @demo component/postVideo
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | param | Object | picker 内容配置 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * param 参数：
   * 
   * | 可以带入拍摄页的内容 | 参数 |
   * | :--: | --:: |
   * | 文本tag | tag: 话题名称（支持添加多个标签，多个标签通过一个空格和一个#号分隔，例如:金月饼 #竞猜活动 #中秋，如需添加多个标签必须设置showNativeTagPage=false）|
   * | 话题Topic <br/> (rich tag) | topic: // 分享一个话题（带头图的tag）<br/> magicFaceId // 如果带魔法表情，必传 <br/> magicName // 如果带魔法表情，必传 <br/> imageUrl <br/> resourceUrl <br/> tag <br/> version |
   * | 魔法表情 | magicName // 识别附带魔法表情(带入魔表时必传) <br/> magicFaceId // 识别附带魔法表情(带入魔表时必传) <br/> imageUrl <br/> resourceUrl <br/> tag <br/> version |
   * | 地理位置 | poiId // 识别附带地理位置(带入地理位置时必传) <br/> address <br/> id <br/> longitude <br/> latitude <br/> title |
   * | 显示native tag聚合页 | showNativeTagPage. // 是否显示native tag聚合页 <br/> 背景：从app外的h5 tag聚合页呼起native的拍摄页时，会在native的拍摄页下补一个native的tag聚合页 <br/> 备注：由于这个字段添加的时候iOS已经有了会打开native的tag聚合页的功能，所以这个字段的定义为：如果不下发或者下发为true，展示native的tag聚合页，反之不展示 |
   * | 回到h5页面 | returnToWeb // 是否回到h5页面。ks-bridge 从 1.0.11 版本开始，默认值为 true，低于 1.0.11 版本，需要手动传值 <br/> 背景：调用 postVideo 拍摄视频，点击发布按钮后，可能命中 ab 实验，跳转到首页关注页，一般活动等 h5 页面希望在调桥拍摄发布后回到 h5 页面，所以通过传 returnToWeb 参数，可以强制回到 h5 页面，而不会跳到首页的关注页（不管是否命中 ab 实验）<br/>当 returnToWeb 值为 true 时，会强制回到 h5 页面；当 returnToWeb 值为 false 或直接不传该参数，具体跳转页面根据当前用户是否命中 ab 实验进行跳转，命中实验则跳转到首页的关注页，未命中则回到 h5 页面<br/>iOS 6.0.4 及以上版本支持 returnToWeb 参数；Android 预计 6.2.2 及以上版本支持
   * | 活动id | activity // 用于区分视频的拍摄来源，具体使用方式请参考示例 demo |
   * | 音乐原声 | musicId // 音乐原声 id <br/> musicType // 音乐类型<br/> 带入音乐原声时，musicId 和 musicType 都要传，客户端从 6.3.2 版本开始支持 |
   * | 是否新启动一个拍摄页 | allowGoBackVideoPost，一般不需要管该字段，值为 ture 表示返回之前的拍摄 false 新起一个拍摄，当 allowGoBackVideoPost 为 true 且客户端真的发现存在一个现有的录制页时，returnToWeb 会不起作用，客户端从 6.3.2 版本开始支持 |
   * | 是否开启“同框”、“跟拍”、“合唱”模式拍摄 | pairedPhoto // 值为包含 photoId、type 属性的对象。photoId 为作品 id，type 为拍摄模式，同框为 "sameFrame", 跟拍为 "followShoot", 合唱为 "chorus"。android 6.6.2  ios 6.6.3 及以上版本支持该功能 |
   * 
   * 注意：
   * 
   * 安卓端使用同框、跟拍模式拍摄，7.7.10 及以上版本才支持回调
   * 
   * 返回参数：
   * ```
   * {
   *     // 1成功 0用户取消
   *     result: 1,
   *     data: {
   *         "uploadId": "94015796-3862-483E-9EA6-FB053D6667B3",   // 用于预览、重传
   *         "coverUrl": "http://ali2.a.yximgs.com/bs2/intownImage/MjAyMTY_o.jpg",   // 视频封面 url，progress 为 100 时才有
   *         "coverKey": "1531293052316_qUkZkqISQ9qv4QLIVI600ssoq", 
   *         "videoUrl": "http://ali2.a.yximgs.com/bs2/intownVideo/MjAyMTY.mp4",   // 视频 url，progress 为 100 时才有
   *         "progress": "100",  // 进度
   *         "filePath": "/var/mobile/Containers/Data/Application/27B876FE-7014-4ED2-9A21-D6943CBEA61F/Documents/gifs/152B184D-C134-4B06-B009-F5813AC46EA8.MOV",   // 用于预览、重传
   *         "photoId": "5xwyk9vaarq9w6u"
   *     }
   * }
   * ```
   */
  postVideo: {
    optHandle: function optHandle() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opt.param = opt.param || {};
      opt.param.returnToWeb = typeof opt.param.returnToWeb === 'boolean' ? opt.param.returnToWeb : true;
      var data = {
        notPromise: true,
        notDelete: true
      };
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(data, opt);
      return data;
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 提现绑定微信或支付宝<br />
   * 对应native接口：bindWithdrawType<br/>
   * 支持版本：客户端17年7月版本，仅 Android 支持<br/>
   * 对接人： songyunlu
   * @method ksBridge.bindWithdrawType
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/bindWithdrawType.demo
   * @demo component/bindWithdrawType
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | category | String | 业务类型，如: sf2018 | √ | - |
   * | type | String | 目前支持： 'wechat', 'alipay' | √ | - |
   * | session | String | 手机验证码 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  bindWithdrawType: true
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 在webview中给指定快手域名注入cookie<br />
   * 使用场景：该接口主要用于安卓客户端注入cookie仅能在页面请求时注入，前端在进行跨子域的ajax请求和jsonp请求时，需要调手动注入快手相关cookie<br/>
   * 对应native接口：injectCookie<br/>
   * 支持版本：客户端17.07版本，仅支持 Android<br/>
   * 对接人： songyunlu
   * @method ksBridge.injectCookie
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/injectCookie.demo
   * @demo component/injectCookie
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | url | String | 要注入cookie的地址 | √ | 需要在快手相关域名白名单里 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  injectCookie: true
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 验证短信验证码?<br />
   * 对应native接口：verifySMSCode<br/>
   * 支持版本：待添加?<br/>
   * 对接人： songyunlu
   * @method ksBridge.verifySMSCode
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/verifySMSCode.demo
   * @demo component/verifySMSCode
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 可空，没有的话客户端默认 账号验证 | X | - |
   * | info | String | 可空，显示再上面的界面信息 | X | - |
   * | type | Number | 验证码的用途，如绑定手机号等 | √ | - |
   * | needMobile | Bool | 是否需要显示输入手机号和国家，如果为false，显示当前账号的手机号（混淆后），国家不可选择，否则显示手机号输入框且国家可以选择，如果账号未绑定手机号，也显示手机号输入框，国家可选择 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     data: {
   *         mobileCode: '123456'// 用户填写的验证码
   *         // 用户对应手机号的counttryCode，逻辑同mobile
   *         mobileCountryCode: '86',
   *         // needMobile为true时用户填写的手机号，
   *         // 以及needMobile为 false时，
   *         // 用户未绑定过手机号，也需要填写的手机号
   *         mobile: ''
   *     }
   * }
   * ```
   */
  verifySMSCode: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 社交分享<br />
   * 对应native接口：socialShare<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.socialShare
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/socialShare.demo
   * @demo component/socialShare
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | paramObject | Object | 分享设置 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  socialShare: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 粉丝支付<br />
   * 对应native接口：fansTopPay<br/>
   * 支持版本：未上线？<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.fansTopPay
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/fansTopPay.demo
   * @demo component/fansTopPay
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | provider | Number | 支付渠道，微信2，支付宝3 | √ | - |
   * | photoId | Number | 视频ID | √ | - |
   * | fen | Number | 订单总金额，金额单位都是分 | √ | - |
   * | followAmountFen | Number | 关注页购买金额 | √ | - |
   * | exploreAmountFen | Number | 发现页购买金额 | √ | - |
   * | nearbyAmountFen | Number | 同城页购买金额 | √ | - |
   * | trackingData | Object | 保留参数 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1, // 支付结果，1为成功
   *     error_msg: '',
   *     data: {
   *         provider: 2, // 支付渠道
   *         ksOrderId: 'Egtg7g9zfsy-2dy20g'
   *     }
   * }
   * ```
   */
  fansTopPay: true
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 代金券支付<br />
   * 对应native接口：couponPay<br/>
   * 注意：需要登录<br/>
   * 对接人： zhuchao、zhangruifeng
   * @method ksBridge.couponPay
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/couponPay.demo
   * @demo component/couponPay
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | ksCouponId | String | 代金券No | √ | - |
   * | fen | Number | 金额 | √ | - |
   * | provider | Number | 渠道 2：微信 3：支付宝 | √ | - |
   * | ksCoin | Number | 快币数 | √ | - |
   * | iapItemName | String | ios支付号 | √ | - |
   * | disableSuccessAlert | Bool |设置 true 时不提示成功弹窗 | X | - |
   * | disableFailAlert | Bool |设置 true 时不提示失败弹窗 | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 注意：两端必传参数不一样
   * android 必传 provider/fen/ksCoin/ksCouponId 字段
   * 
   * iOS 必传 ksCoin/fen/iapItemName 字段，
   * disableSuccessAlert、disableFailAlert 为 iOS 7.3.30及以上版本新增字段
   * 
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   *     data: {
   *         provider: 2, // 支付渠道
   *         ksOrderId: 'Egtg7g9zfsy-2dy20g'
   *     }
   * }
   * ```
   */
  couponPay: true
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 通用分享<br />
   * 对应native接口：commonShare<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.commonShare
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/commonShare.demo
   * @demo component/commonShare
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | param | Object | 分享设置 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * param:
   *
   * | 参数 | 类型 | 描述 |
   * | :--: | :--: | :--: |
   * | platform | Array | 分享的平台 |
   * | imgUrl | String | 图片URL，与 hdImageData 二选一 |
   * | caption | String | 标题 |
   * | desc | String | 描述 |
   * | siteName | String | 显示在分享卡片上的文案 |
   * | siteUrl | String | 实际URL |
   * | smallApp | Object | 小程序参数，例如：{"path":xxx, "app_id":xxxxx} |
   * | hdImageData | String | 高清大图数据，base64String，与 imgUrl 二选一 |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  commonShare: {
    optHandle: function optHandle(opt) {
      var defaultImgUrl = 'https://ali.static.yximgs.com/s1/archive/i/common/logo.png';
      opt.param = opt.param || {};
      opt.param.imgUrl = opt.param.imgUrl || defaultImgUrl;
      return opt;
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 调起第三方支付<br />
   * 对应native接口：startGatewayPay<br/>
   * 对接人： zhujiahui
   * @method ksBridge.startGatewayPay
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/startGatewayPay.demo
   * @demo component/startGatewayPay
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | data | Object | version,format,sign,timestamp,biz_content等等 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // ?四种结果：1: 成功、0: 用户取消，其他：出错
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  startGatewayPay: true
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 播放快手课堂的长视频<br />
   * 对应native接口：startPlayLongVideo<br/>
   * 对接人： zhaorong
   * @method ksBridge.startPlayLongVideo
   * @category Component
   * @version >=1.0.1
   * @example ./apis/component/startPlayLongVideo.demo
   * @demo component/startPlayLongVideo
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 标题 | √ | - |
   * | coverUrl | String | 封面URL | √ | - |
   * | contentUrl | String | 视频URL | √ | - |
   * | contentWidth | Number | ？ | √ | - |
   * | contentHeight | Number | ？ | √ | - |
   * | duration | Number | ？ | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  startPlayLongVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 录音<br />
   * 对应native接口：startAudioRecord<br/>
   * 对接人： fangchangquan
   * @method ksBridge.startAudioRecord
   * @category Component
   * @version >=1.0.3
   * @example ./apis/component/startAudioRecord.demo
   * @demo component/startAudioRecord
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | timeLimit | number | 录制时长 | √ | 单位 ms，值必须大于 0 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  startAudioRecord: true
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 登录<br />
   * 对应native接口：login<br/>
   * 支持版本：客户端17.09版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.login
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/login.demo
   * @demo component/login
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  login: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 登出<br />
   * 对应native接口：logout<br/>
   * 对接人： songyunlu
   * @method ksBridge.logout
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/logout.demo
   * @demo component/logout
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  logout: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 删除账号？<br />
   * 对应native接口：deleteAccount<br/>
   * 支持版本：暂未上线?<br/>
   * 对接人： songyunlu
   * @method ksBridge.deleteAccount
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/deleteAccount.demo
   * @demo component/deleteAccount
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | info | Object | 信息？| √ | { reasonId: 3, extraInfo: 'text' } |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  deleteAccount: true
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 第三方登录<br />
   * 对应native接口：verifyThirdPartyLogin<br/>
   * 对接人： songyunlu, guoda
   * @method ksBridge.verifyThirdPartyLogin
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/verifyThirdPartyLogin.demo
   * @demo component/verifyThirdPartyLogin
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | platform | String | 10几种 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '', //result 不为1时返回错误信息(国际化)
   *     accessToken:'xsdfsdf',
   *     ...
   * }
   * ```
   */
  verifyThirdPartyLogin: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 选择手机国家区号<br />
   * 对应native接口：selectCountryPhoneCode<br/>
   * 对接人： songyunlu
   * @method ksBridge.selectCountryPhoneCode
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/selectCountryPhoneCode.demo
   * @demo component/selectCountryPhoneCode
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     phoneCode: '86'
   * }
   * ```
   */
  selectCountryPhoneCode: true
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 调起录制视频(直播身份认证，已过期)<br />
   * 对应native接口：captureCertVideo<br/>
   * 注意：需要登录，是否还要在 ksbridge 中添加？<br/>
   * 对接人： songyunlu
   * @method ksBridge.captureCertVideo
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/captureCertVideo.demo
   * @demo component/captureCertVideo
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | showUserPortrait | Bool | 是否显示用户轮廓 | X | 默认false |
   * | steps | Array | 验证步骤 | √ | 长度不限，对象数组，{ text: '眨眨眼', startTime: 0, duration: 3300 } |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   *     napshot: 'base 64 image data',
   *     uploadToken: 'xxx',
   *     ticket: 'xxxx'
   * }// positive绿色, negative 红色, neutral
   * ```
   */
  captureCertVideo: true
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 身份证视频上传接口（业务通用）<br />
   * 对应native接口：uploadCertVideo<br/>
   * 支持版本：客户端2017.11月版本<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.uploadCertVideo
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/uploadCertVideo.demo
   * @demo component/uploadCertVideo
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | uploadToken | String | - | √ | - |
   * | showUserPortrait | Bool | 是否显示用户轮廓 | X | 默认false |
   * | steps | Array | 验证步骤 | √ | 长度不限，对象数组，{ text: '眨眨眼', startTime: 0, duration: 3300 } |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   *     napshot: 'base 64 image data',
   *     uploadToken: 'xxx',
   *     ticket: 'xxxx'
   * }// positive绿色, negative 红色, neutral
   * ```
   */
  uploadCertVideo: true
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 绑定通讯录<br />
   * 对应native接口：uploadContacts<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.uploadContacts
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/uploadContacts.demo
   * @demo component/uploadContacts
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  uploadContacts: true
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 发送短信<br />
   * 对应native接口：sendSMS<br/>
   * 支持版本：客户端2018.7月新用户邀请活动更新<br/>
   * 对接人： songyunlu
   * @method ksBridge.sendSMS
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/sendSMS.demo
   * @demo component/sendSMS
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | encryptedMobile | String | 加密后的发送者的手机号，支持多个，逗号分割 | X | - |
   * | mobile | String | 手机号，改成支持多个，逗号分割 | √ | - |
   * | content | String | 短信内容 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: ''
   * }
   * ```
   */
  sendSMS: true
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 根据加密后通讯录名称获取原始名称<br />
   * 对应native接口：decryptContactsName<br/>
   * 支持版本：客户端18.7月新用户邀请活动更新<br/>
   * 对接人： songyunlu
   * @method ksBridge.decryptContactsName
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/decryptContactsName.demo
   * @demo component/decryptContactsName
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | encryptedName | String | 加密后的通讯录名称 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     data: [{
   *         encryptedName: 'key1',
   *         name: '小白'
   *     }
   *     ...
   *     ],
   *     error_msg: '',
   * }
   * ```
   */
  decryptContactsName: true
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 绑定手机号<br />
   * 对应native接口：bindPhone<br/>
   * 注意：需要登录<br/>
   * 对接人： songyunlu
   * @method ksBridge.bindPhone
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/bindPhone.demo
   * @demo component/bindPhone
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  bindPhone: true
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 下载<br />
   * 对应native接口：download<br/>
   * 支持版本：客户端18.01月底上线<br/>
   * 对接人： songyunlu
   * @method ksBridge.download
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/download.demo
   * @demo component/download
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | String | 类型，start 重新开始 resume 继续或重新下载  pause 暂停 stop 停止 | √ | - |
   * | url | String | 下载地址 | √ | 使用 https 协议有问题 |
   * | fileType | String | 安卓上文件类型为video或image放在相册目录, 其它放在Download目录 | X | - |
   * | photoId | Number | ? | X | - |
   * | clickType | Number | actionBar类型 | X | - |
   * | downloadId | String | 下载id，自定义的 ID，估计是用于唯一标示当前的下载，如果较真可以找客户端确认下 | X | - |
   * | notificationHidden | Bool | ? | X | - |
   * | extraInfo | String | 目前仅支持 game | X - |
   * | downloadName | String | 下载文件名（apk时用包名） | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 注意：
   * 如果要实现 apk 安装包下载一次，第二次再调直接安装不重新下载的效果，必须要配合 downloadProgress、installApk 一起使用
   * 详细调用参考 downloadProgress demo，且 download 中的 extraInfo 必传 game，
   * download、downloadProgress、installApk 三个 bridge 是通过 downloadId 进行关联的
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   *     // fail resume cancel pause start complete progress
   *     stage: "resume",
   *     percent: 33 // 0~100
   * }
   * ```
   */
  download: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 城市选择<br />
   * 对应native接口：selectCity<br/>
   * 支持版本：客户端预计2017.12.26上线版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.selectCity
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/selectCity.demo
   * @demo component/selectCity
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1, // 1成功 0用户取消
   *     error_msg: '',
   *     data: {
   *         code: '', // 选中城市代码
   *         provinceName: '', // 省名称
   *         cityName: '' // 城市名称
   *     }
   * }
   * ```
   */
  selectCity: true
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * MMU活体验证接口<br />
   * 对应native接口：verifyLiveUser<br/>
   * 支持版本：客户端18.06版本，账号申诉需求<br/>
   * 对接人： songyunlu
   * @method ksBridge.verifyLiveUser
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/verifyLiveUser.demo
   * @demo component/verifyLiveUser
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | category | String | 业务分类，目前只有申诉 | √ | - |
   * | preStartDuration | Number | 毫秒 | √ | - |
   * | preStartHint | Array | 提示？ | √ | - |
   * | steps | Array | 验证任务 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // ?四种结果：1: 成功、0: 用户取消，其他：出错
   *     result: 1,
   *     error_msg: '',
   * }
   * ```
   */
  verifyLiveUser: true
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 发布作品<br />
   * 注意：该 bridge 商业化业务特有的<br/>
   * 对应native接口：publishWorks<br/>
   * 对接人： songyunlu
   * @method ksBridge.publishWorks
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/publishWorks.demo
   * @demo component/publishWorks
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | triggerType | Number | 0前端调用（查询是否有发布中作品）,1用户主动点击（触发发布流程）,2 show, 3 hide | √ | - |
   * | photoId | String | 需要编辑去水印的photoId | √ | - |
   * | bottomDistance | Number | 发布状态栏距离底部距离，单位px | √ | - |
   * | success | Function | 成功回调函数 | X | 当作品发布状态发生变化时会调用 |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 0失败，1成功，2发布中，3取消，4未知（查询无作品发布）
   *     result: 1,
   *     error_msg: '',
   *     // string类型，上传成功的photoId
   *     photoId: 'xxxxxxxx'
   * }
   * ```
   */
  publishWorks: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 对通过手机登录的用户进行短信验证码验证<br />
   * 对应native接口：verifyAccount<br/>
   * 对接人： songyunlu
   * @method ksBridge.verifyAccount
   * @category Component
   * @version >=1.0.0
   * @example ./apis/component/verifyAccount.demo
   * @demo component/verifyAccount
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | info | String | 提示信息，可空 | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 四种结果：成功、用户取消、未登录、未绑定手机
   *     result: 1,
   *     error_msg: '',
   *     data: {}
   * }
   * ```
   */
  verifyAccount: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 调起并进入私信群聊<br/>
   * 对应native接口：enterGroupChat<br/>
   * 对接人：hanchen<br/>
   * @method ksBridge.enterGroupChat
   * @category Component
   * @version >=1.0.6
   * @example ./apis/component/enterGroupChat.demo
   * @demo component/enterGroupChat
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | groupId | String | 群聊ID | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  enterGroupChat: true
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 支付网关提现<br/>
   * 对应native接口：startGatewayWithdraw<br/>
   * 对接人：zhujiahui<br/>
   * @method ksBridge.startGatewayWithdraw
   * @category Component
   * @version >=1.0.7
   * @example ./apis/component/startGatewayWithdraw.demo
   * @demo component/startGatewayWithdraw
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | url | String | 需要在支付网关隔离环境里打开的页面地址 | √ | - |
   **/
  startGatewayWithdraw: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 通过base64保存图片到手机相册<br/>
   * 客户端的支持版本： android 6.5.3，iOS 6.5.5以上<br/>
   * 对应native接口：saveImage<br/>
   * 对接人：zhaorong<br/>
   * @method ksBridge.saveImage
   * @category Component
   * @version >=1.0.14
   * @example ./apis/component/saveImage.demo
   * @demo component/saveImage
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | base64String | String | 图片base64编码 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  saveImage: true
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 给好友发送私信<br/>
   * 对应native接口：sendImFriendMessage<br/>
   * 对接人：lianxin<br/>
   * @method ksBridge.sendImFriendMessage
   * @category Component
   * @version >=1.0.14
   * @example ./apis/component/sendImFriendMessage.demo
   * @demo component/sendImFriendMessage
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | targetType | Number | 发送对象类型 | 必选 | 0 是单聊， 4是群聊 |
   * | targetId | Number | 对象ID | 必选 | 如果是用户，则为用户id, 如果是群，则是groupId |
   * | msgType | Number | 消息类型 | 必选 | 0 是文本，2 是 图片   9 是Link  |
   * | text | String | 文本消息类型时对应发送内容 | 必选 | 与image属性 link属性互斥 |
   * | image | Object | 图片消息类型时对应发送内容 | 必选 | 与text属性 link属性互斥 |
   * | link | Object | link消息类型时对应发送内容 | 必选 | 与text属性 image属性互斥 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  sendImFriendMessage: true
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取客户端默认截图（提供裁剪压缩功能）<br/>
   * 对应native接口：selectScreenshot<br/>
   * 支持版本：Android、iOS >=6.6.6版本<br/>
   * 对接人：hanchen<br/>
   * @method ksBridge.selectScreenshot
   * @category Component
   * @version >=1.0.15
   * @example ./apis/component/selectScreenshot.demo
   * @demo component/selectScreenshot
   * @description 
   * 
   * 调用参数：
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | maxFileSize | Number | 字节单位 | X | 不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大 |
   * | maxWidth | Number | 像素单位 | X | 不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大 |
   * | maxHeight | Number | 像素单位 | X | 不存在则为不限制，原图超过该值时自动压缩，建议设置，否则图太大 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  selectScreenshot: true
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 直接调起微信登录，并且native也会变为登录状态。<br/>
   * 对应native接口：wechatLogin<br/>
   * 对接人：chenxiaolong<br/>
   * @method ksBridge.wechatLogin
   * @category Component
   * @version >=1.0.16
   * @example ./apis/component/wechatLogin.demo
   * @demo component/wechatLogin
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  wechatLogin: true
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 通用的绑定第三方账号（微信/支付宝）<br/>
   * 对应native接口：authThirdPartyAccount<br/>
   * 对接人：zhujiahui<br/>
   * @method ksBridge.authThirdPartyAccount
   * @category Component
   * @version >=1.0.16
   * @example ./apis/component/authThirdPartyAccount.demo
   * @demo component/authThirdPartyAccount
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | provider | String | 平台标识 | X | wechat | alipay |
   * | auth_param | String | 授权参数 | X | 微信或支付宝的授权参数 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  authThirdPartyAccount: true
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 查看当前下载进度<br />
   * 对应native接口：downloadProgress<br/>
   * 支持版本：仅支持 Android<br/>
   * 对接人： xinyangxi
   * @method ksBridge.downloadProgress
   * @category Component
   * @version >=1.0.18
   * @example ./apis/component/downloadProgress.demo
   * @demo component/downloadProgress
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | String | 类型，start 重新开始 resume 继续或重新下载  pause 暂停 stop 停止 | √ | - |
   * | url | String | 下载地址 | √ | - |
   * | downloadId | String | 下载id，自定义的 ID，估计是用于唯一标示当前的下载，如果较真可以找客户端确认下 | √ | - |
   * | downloadName | String | 下载文件名（apk时用包名） | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     // 当进度为 100 时可以调用 installApk 进行安装
   *     percent: 33 // 0~100
   * }
   * ```
   */
  downloadProgress: true
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 安装 apk 包<br />
   * 对应native接口：installApk<br/>
   * 支持版本：仅支持 Android<br/>
   * 对接人： xinyangxi
   * @method ksBridge.installApk
   * @category Component
   * @version >=1.0.18
   * @example ./apis/component/installApk.demo
   * @demo component/installApk
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | String | 类型，start 重新开始 resume 继续或重新下载  pause 暂停 stop 停止 | √ | - |
   * | url | String | 下载地址 | √ | - |
   * | downloadId | String | 下载id，自定义的 ID，估计是用于唯一标示当前的下载，如果较真可以找客户端确认下 | √ | - |
   * | downloadName | String | 下载文件名（apk时用包名） | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  installApk: true
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取 currency 参数<br />
   * 对应native接口：iapCurrencyWithParams<br/>
   * 支持版本：仅支持 iOS 客户端 7.3.20 及以上版本<br/>
   * 对接人： zhuchao
   * @method ksBridge.iAPCurrency
   * @category Component
   * @version >=2.0.0
   * @example ./apis/component/iAPCurrency.demo
   * @demo component/iAPCurrency
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数:
   * ```
   * {
   *     result: 1, // 1成功
   *     currency: 'xxxx', // currency 参数
   * }
   * ```
   */
  iAPCurrency: true
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 通用分享<br />
   * 对应native接口：share<br/>
   * 注意：需要登录<br/>
   * 对接人： xuming
   * @method ksBridge.share
   * @category Component
   * @version >=2.0.0
   * @example ./apis/component/share.demo
   * @demo component/share
   * @description
   *
   * 接入wiki:https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=429799993 <br/>
   * 详情wiki:https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=410888352
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | param | Object | 分享设置 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * param:
   *
   * | 参数 | 类型 | 描述 | 必选 |
   * | :--: | :--: | :--: | :--: |
   * | subBiz | String | 分享对应的业务 | √ |
   * | shareResourceType | String | 分享业务对象的类型（可以用来区分场景） | X |
   * | shareObjectId | String | 分享业务对象的唯一标识，非空的字符串，举例：userId，photoId等 | √ |
   * | showSharePanel | Bool | 是否展示面板 | X |
   * | shareDirectActionUrl | String | 直接发起分享的必要参数 | X |
   * | logParams | String | JSON字符串，该字段传的内容，客户端将直接透传到打点平台 | X |
   * | tokenStoreParams | Object | 定制化回流的文案，图片等，具体会在中台的show/any接口生效，参考下面示例 | X |
   * | commonConfigs | Object | 通用的期望configs，这里的configs回和channel中的expectedConfigs作合并，以custom的为准，这里的参数会传给server，。这里的config会带到show/any的请求中，期望使用这些参数，是否使用sever 端决定。参考下面示例 | X |
   * | forceCommonConfigs | Object | 通用的强制设置configs，这里的configs回和channel中的forceConfigs作合并，以custom的为准，这里的参数不会传给server。这里的config会覆盖show/any的返回值，参考下面示例 | X |
   * | extraChannelOptions | Array | 不同的分享渠道特殊配置，参考下面示例 | X |
   * 
   * 返回参数：
   * ```
   * {
   *     "result": 0,
   *     "error_msg": "",
   *     "response": {
   *         "share": {
   *             "result": 1,
   *             "errorMsg": null,
   *             "shareMethod": "TOKEN",
   *             "shareChannel": "COPY_LINK",
   *             "shareMode": "APP",
   *             "kpn": "KUAISHOU",
   *             "subBiz": "IM",
   *             "appName": "ztShareTest",
   *             "appIconUrl": "",
   *             "shareObject": {
   *                 "shareObjectId": "100021728",
   *                 "shareResourceType": "",
   *                 "shareId": "63146521687",
   *                 "shareMessage": "我和4个人正在快手群聊【小吃货们】里聊天， http://www.gifshow.com/s/y2irAQ9n 点击链接加入我们；或者复制这条消息后打开快手",
   *                 "extParams": {}
   *             }
   *         }
   *     }
   * }
   * ```
   */
  share: true
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 商家号业务用于获取特性商业信息、商业逻辑操作<br/>
   * 对应native接口：businessAction<br/>
   * 对接人：liuming<br/>
   * @method ksBridge.businessAction
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/businessAction.demo
   * @demo component/businessAction
   * @description 
   * 
   * API的action类型随时会新增,具体可以参考[附件](https://static.yximgs.com/udata/pkg/ks-ad-fe/bridge.4f84494d.pdf)
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | Enum |  操作指令，根据前端传入指令调用不同native方法 | √ | - |
   * | data | String | json字符串，根据type不同，获取不同的数据，传入不同数据 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  businessAction: true
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 粉丝头条接入支付sdk账户充值功能<br/>
   * 对应native接口：startDeposit<br/>
   * 对接人：zhaoyang03<br/>
   * @method ksBridge.startDeposit
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/startDeposit.demo
   * @demo component/startDeposit
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | provider | String | 充值支付类型（枚举） | √ | wechat/alipay,可为空 |
   * | accountGroupKey | String | 账户标识key | √ | - |
   * | data | Object | 参数 | √ | - |
   * | complete | Function | 回调函数名 | √ | - |
   **/
  startDeposit: true
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 调起支付收银台<br/>
   * 对应native接口：startKspayOrderPrepay<br/>
   * 对接人：zhujiahui<br/>
   * @method ksBridge.startKspayOrderPrepay
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/startKspayOrderPrepay.demo
   * @demo component/startKspayOrderPrepay
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | merchantId | String | 商户ID | √ | 接入之前联系 @孙为强  申请 |
   * | outOrderNo | String | 业务订单号 | √ | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  startKspayOrderPrepay: true
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置关注栈<br/>
   * 对应native接口：setPageFollowRefer<br/>
   * 对接人：tanbing<br/>
   * @method ksBridge.setPageFollowRefer
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/setPageFollowRefer.demo
   * @demo component/setPageFollowRefer
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | followRefer | String | 要设置的关注栈refer | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  setPageFollowRefer: true
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 检测是否授权日历<br/>
   * 对应native接口：authorizationStatusForCalendar<br/>
   * 对接人：huangyiwei<br/>
   * @method ksBridge.authorizationStatusForCalendar
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/authorizationStatusForCalendar.demo
   * @demo component/authorizationStatusForCalendar
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  authorizationStatusForCalendar: true
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 对日历进行增删改查<br/>
   * 对应native接口：changeEventForCalendar<br/>
   * 对接人：huangyiwei<br/>
   * @method ksBridge.changeEventForCalendar
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/changeEventForCalendar.demo
   * @demo component/changeEventForCalendar
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | method | String | 操作类型，目前支持 add、delete、search | √ | 删除、更新均为 delete |
   * | event | Object | 事件配置 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * event 说明：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | Number | 日历类型 | X | 1:每天/ 2:工作日/ 3:周末 |
   * | title | String | 标题 | X | - |
   * | note | String | 提示 | X | - |
   * | startDay | String | 开始时间| X | - |
   * | endDay | String | 结束时间 | X | - |
   * | url | String | 跳转地址 | X | 目前安卓不支持 ios有bug |
   * | eventId | String | 事件id | X | 删除更新时需要该 id |
   * 
   * 返回参数：
   * 
   * ```json
   * {
   *     "result": 1,
   *     "eventId": "50"
   * }
   * 
   * eventId 仅在 add 时会返回，method 为 delete、search 时，只有 result
   * 
   * 更多细节参考：[桥定义](https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=390952222)，[需求文档](https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=483860832)
   **/
  changeEventForCalendar: true
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * webview容器截屏，可以把当前屏幕高度的H5截图下来，保存在相册里<br/>
   * 对应native接口：renderImage<br/>
   * 对接人：liuming<br/>
   * @method ksBridge.renderImage
   * @category Component
   * @version >=2.0.1
   * @example ./apis/component/renderImage.demo
   * @demo component/renderImage
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | String | 操作类型,这里是3个枚举值， start: 打开一个影藏的webview.  end:条件哦，启动截屏    failure: 条件不ok，放弃截屏 | √ |这里需要组合调用，因为隐藏的view不可见，所以当你调用end或者failure。执行的是 start的回调函数，具体看例子 |
   * | data | Object | 只包含一个参数imageUrl，传入一个H5的地址，就是你要截屏的页面 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  renderImage: true
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 关注/取消关注用户<br/>
   * 对应native接口：requestFollowUserV2<br/>
   * 对接人：iOS：刘永超、安卓：柯国宇<br/>
   * @method ksBridge.requestFollowUserV2
   * @category Component
   * @version >=2.0.2
   * @example ./apis/component/requestFollowUserV2.demo
   * @demo component/requestFollowUserV2
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | userId | String | 被关注/取消关注用户id | √ | - |
   * | following | Boolean | 操作类型 关注/取消关注 | √ | - |
   * | activityId | String | 活动ID | √ | - |
   * | info | Object | 用于扩展关注参数 | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 注意：
   * 关注的账号需要后端加白名单，可联系对应PM 顾小羽
   * 测试时，可打开开关 摇一摇-》社交tab-》关注-Bridge禁用HTTPS校验 【iOS】/ 开启HTTP页面调用关注jsbridge【Android】
   * 
   * 更详细信息参考[wiki](https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=504451510)
   * 
   **/
  requestFollowUserV2: true
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gete2__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFeed__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queryKCardStatus__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__submitData__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getClientLogInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setClientLogCurrentUrl__ = __webpack_require__(70);







var data = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_5__getClientLogInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__setClientLogCurrentUrl__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__gete2__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__getFeed__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__queryKCardStatus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__submitData__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: data
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取imsi<br />
   * 对应native接口：gete2<br/>
   * 对接人： songyunlu
   * @method ksBridge.gete2
   * @category Data
   * @version >=1.0.0
   * @example ./apis/data/gete2.demo
   * @demo data/gete2
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1, // 1为成功, 其他为失败
   *     error_msg: '',
   *     data: {
   *         e2: xxx, // 机密后imsi
   *         iv2: xxx // 初始向量
   *     }
   * }
   * ```
   */
  gete2: true
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取视频详细信息<br />
   * 对应native接口：getFeed<br/>
   * 支持版本：客户端18.01月底上线版本<br/>
   * 注意：兼容转义字符问题，该接口 iOS 返回 object，使用时注意。<br/>
   * 对接人： songyunlu
   * @method ksBridge.getFeed
   * @category Data
   * @version >=1.0.0
   * @example ./apis/data/getFeed.demo
   * @demo data/getFeed
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | photoId | String | photoId | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     result: 1, // 1为成功, 其他为失败
   *     error_msg: '' // result 不为1时返回错误信息(国际化)
   *     data: feedObject,
   *     ext_data: {
   *         photo_id: "", // String
   *         user_id: "", // String
   *         llsid: "" // String
   *     }
   * }
   * ```
   * 
   * feedObject:
   * ```
   * {
   *     actionBarRatio: 1,
   *     adType: "1",
   *     alertNetMobile: true,
   *     appName: "蜀门手游.apk",
   *     backgroundColor: "#ff61d575",
   *     chargeInfo: "xxxxxxxxxx",
   *     conversionType: 1,
   *     creativeId: 96097,
   *     displayType: "2",
   *     extData: "",
   *     hideLabel: false,
   *     orderId: 0,
   *     packageName: "com.ycgame.t11",
   *     photoPage: "",
   *     preloadLandingPage: false,
   *     showEndOption: true,
   *     sourceDescription: "广告",
   *     sourceType: 1,
   *     textColor: "#ffffffff",
   *     title: "立即下载",
   *     tracks: [{…}],
   *     url: "download://dlp.shumensy.com/t11_1192_618.apk",
   *     useH5: false
   * }
   * ```
   */
  getFeed: true
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  queryKCardStatus: true
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * A 启动 B，B 回传数据给 A；A 从 B 中获取值<br />
   * 对应native接口：submitData<br/>
   * 对接人： songyunlu
   * @method ksBridge.submitData
   * @category Data
   * @version >=1.0.0
   * @example ./apis/data/submitData.demo
   * @demo data/submitData
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | String | 业务类型，例如 captcha | √ | - |
   * | data | Object | 数据内容 | √ | { token: 'xxxxx' } |
   *
   */
  submitData: true
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 用于打通端内h5页面和客户端页面的pv打点。获取客户端打点相关信息。<br/>
   * 对应native接口：getClientLogInfo<br/>
   * 对接人：miaowei<br/>
   * @method ksBridge.getClientLogInfo
   * @category Data
   * @version >=1.0.15
   * @example ./apis/data/getClientLogInfo.demo
   * @demo data/getClientLogInfo
   * @description
   *
   * 都是从 `logsdk` 中获取，包括refer页信息，当前页信息，和sessinId等。注意：没有result字段（bug）。
   *
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   *
   * 返回参数：
   *
   * ```js
   * {
   *     // 当前webview的页面信息
   *     currentUrlPackage:{
   *         cachedSize: -1,
   *         category: 0,
   *         entryPageId: "",
   *         entryPageSource: "",
   *         identity: "f03bd21e-e3ab-42c8-8d96-9093ebcb4e73",
   *         page: 0,
   *         pageSeq: 0,
   *         params: "",
   *         subPages: "",
   *     },
   *     // 来源页面
   *     referUrlPackage:{
   *         cachedSize: -1,
   *         // 页面分类
   *         category: 1,
   *         // 入口页面(需要继承)
   *         entryPageId: "02c4d0ea-3d4d-4822-b6d5-95c41bd610d8",
   *         // 入口页面(需要继承)
   *         entryPageSource: "MENU",
   *         // pv唯一ID
   *         identity: "02c4d0ea-3d4d-4822-b6d5-95c41bd610d8",
   *         // 页面ID （因技术限制只能用数字）
   *         page: 5,
   *         // 页面被访问的序号
   *         pageSeq: 7,
   *         // 对应打点平台的 params
   *         params: "",
   *         // 对应打点平台的 subPages
   *         subPages: "",
   *     },
   *     // 通过哪个按钮点进来的
   *     referElementPackage:{
   *         // element action （因技术限制只能用数字）
   *         action: 1239,
   *         cachedSize: 17,
   *         index: 0,
   *         name: "LABORATORY",
   *         params: "",
   *         status: 0,
   *         type: 15,
   *         value: 0,
   *     },
   *     sessionId: "1b9de626-6014-4818-8c20-cebcf6adce7b"
   * }
   * ```
   **/
  getClientLogInfo: true
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 对 clientLog 设定当前页面信息<br/>
   * 对应native接口：setClientLogCurrentUrl<br/>
   * 对接人：miaowei<br/>
   * @method ksBridge.setClientLogCurrentUrl
   * @category Data
   * @version >=1.0.15
   * @example ./apis/data/setClientLogCurrentUrl.demo
   * @demo data/setClientLogCurrentUrl
   * @description
   *
   * 注意：没有result字段（bug）
   *
   * 操作 `logsdk` 改变当前webview的页面信息。第一次调用会发送pv打点。后续是跳页动作，会发送leave和pv。
   *
   * 通过当前bridge将h5页面变成客户端页面（在clientLog层面）。这样h5页面的pv和refer都会被正确的处理。解决了之前refer丢失的问题。并且页面展现时长也交由客户端logsdk维护，更准确。
   *
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | currentUrlPackage | Object | 当前页面的信息 | O | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   *
   * currentUrlPackage 示例（参数都是必传）：
   *
   *
   * ```js
   * {
   *     // 页面类型 一般是 1
   *     category: 1,
   *     // 打点平台页面名（因技术限制只能是数字）
   *     page: 554,
   *     // 打点平台 sub_pages
   *     subPages: 'titleSearchView',
   *     // 打点平台 params
   *     params: 'foo=bar'
   * }
   * ```
   *
   * 返回值示例：
   *
   * ```
   * {
   *     result:1,
   *     currentUrlPackage: {
   *         cachedSize: -1,
   *         // 页面分类
   *         category: 1211,
   *         // 入口页面(后续打点需要带上)
   *         entryPageId: "02c4d0ea-3d4d-4822-b6d5-95c41bd610d8",
   *         // 入口页面(后续打点需要带上)
   *         entryPageSource: "MENU",
   *         // pv唯一ID
   *         identity: "3de0aac5-6661-4617-bc5b-46b6a16f2381",
   *         // 打点平台页面名 （因技术限制只能用数字）
   *         page: 554,
   *         // 页面被访问的序号
   *         pageSeq: 8,
   *         // 打点平台 params
   *         params: "foo=bar",
   *         // 打点平台 subPages
   *         subPages: "",
   *     }
   * }
   * ```
   **/
  setClientLogCurrentUrl: true
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__openWechatMiniProgram__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kuaiXiangRegisterSuccess__ = __webpack_require__(73);



var page = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_2__kuaiXiangRegisterSuccess__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__openWechatMiniProgram__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  page: page
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 打开微信小程序<br />
   * 对应native接口：openWechatMiniProgram<br/>
   * 对接人： chenyuzhe
   * @method ksBridge.openWechatMiniProgram
   * @category Page
   * @version >=1.0.0
   * @example ./apis/page/openWechatMiniProgram.demo
   * @demo page/openWechatMiniProgram
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | originalID | String | 微信小程序原始ID，AES加密，一般由服务端加密给到前端 | √ | 常用参数 |
   * | path | String | 跳转到微信小程序对应的path页面 | √ | 常用参数 |
   * | success | Function | 成功回调函数 | X | 常用参数 |
   * | fail | Function | 失败回调函数 | X | 常用参数 |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 加密规则详见：https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=382765812 【感谢@zhaopeng05大佬的总结】
   * 
   * 加密秘钥：https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=382766285 【有权限控制，如有需要请联系@songyunlu、@fangchangquan】
   *
   * 返回参数：
   * ```
   * {
   *     extMsg：对应JsApi navigateBackApplication中的extraData字段数据
   *     type：未知
   *     errCode：错误码，1代表成功，-2代表小程序未上线，-3代表未关联（猜测，目前未找到相关错误码文档）
   *     errStr：错误描述，当前code= -2、-3未返回错误描述
   * }
   * ```
   */
  openWechatMiniProgram: true
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 【快接单】- 发布页设置快享跳转页<br/>
   * 对应native接口：kuaiXiangRegisterSuccess<br/>
   * 对接人：leijie<br/>
   * @method ksBridge.kuaiXiangRegisterSuccess
   * @category Page
   * @version >=2.0.1
   * @example ./apis/page/kuaiXiangRegisterSuccess.demo
   * @demo page/kuaiXiangRegisterSuccess
   * @description 
   * 
   * 快接单业务专用bridge
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | kxHomePageUrl | string | 注册成功后点击跳转的页面 | √ | -
   **/
  kuaiXiangRegisterSuccess: true
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDeviceInfo__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLocation__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hasInstalledApp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__launchApp__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emitFreeTrafficUpdate__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getDeviceSecretInfo__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scanCode__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setClipBoard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__installedAppVersion__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getDarkMode__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__openBrowser__ = __webpack_require__(85);












var system = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_11__openBrowser__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__getDarkMode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__installedAppVersion__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__setClipBoard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__scanCode__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__getDeviceSecretInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getDeviceInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__getLocation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__hasInstalledApp__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__launchApp__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__emitFreeTrafficUpdate__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  system: system
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取设备信息<br />
   * 使用场景：根据设备信息进行特殊判断或逻辑处理<br />
   * 对应native接口：getDeviceInfo<br/>
   * 支持版本：客户端预计18年-01月底上线版本，有更新<br/>
   * 对接人： songyunlu
   * @method ksBridge.getDeviceInfo
   * @category System
   * @version >=1.0.0
   * @example ./apis/system/getDeviceInfo.demo
   * @demo system/getDeviceInfo
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * 
   * iOS：
   * ```
   * {
   *     result: 1, // 1为成功, 其他为失败
   *     error_msg: '' // result不为1时回传错误信息
   *     data: {
   *         appVersion: '1.23.34.3',
   *         networkType: '3G',
   *         manufacturer: 'Apple',
   *         model: 'iPhone 5',
   *         systemVersion: '9.0',
   *         locale: 'en-US',
   *         uuid: '123ksdf-123dfs-sdfsd-sdfs',
   *         idfa: 'xxxxxxx'  // ios独有？android里没有
   *         screenWidth: 320,
   *         screenHeight: 640,
   *         statusBarHeight: 40, // 状态栏高度
   *         titleBarHeight: 88, // 导航栏高度
   *         imei: 'xxx',
   *         androidId: 'xxx',
   *         mac: 'xxx'
   *     }
   * }
   * ```
   * 
   * Android：
   * ```
   * {
   *     result: 1, // 1为成功, 其他为失败
   *     error_msg: '' // result不为1时回传错误信息
   *     data: {
   *         appVersion: '5.5.2.9999',
   *         networkType: 'WIFI',
   *         manufacturer: 'HUAWEI(MHA-L29)',
   *         model: 'MHA-L29',
   *         systemVersion: 'ANDROID_7.0',
   *         locale: 'zh_CN_#Hans',
   *         uuid: 'ANDROID_5bc489e5e0effdbd',
   *         screenWidth: 320,
   *         screenHeight: 640,
   *         statusBarHeight: 72,
   *         titleBarHeight: 150,
   *         imei: '861957039491310',
   *         androidId: '5bc489e5e0effdbd',
   *         mac: '44:C3:46:2E:9C:F8'
   *     }
   * }
   * ```
   * 
   * iOS 端关于 networkType 的说明：
   * 这个字段值是拼接的，格式：运营商_网络类型，例如：中国移动_5
   * 运营商的值可能为：
   * 
   * 0：未知
   * 
   * 1：中国移动
   * 
   * 2：中国联通
   * 
   * 3：中国电信
   * 
   * 9：其他运营商
   * 
   * 网络类型值可能为：
   * 
   * 0：无网络
   * 
   * 1：2G
   * 
   * 2：3G
   * 
   * 3：4G
   * 
   * 4：未知
   * 
   * 5：WIFI
   * 
   * 6：5G
   */
  getDeviceInfo: true
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取经纬度<br />
   * 对应native接口：getLocation<br/>
   * 支持版本：18年12月中旬上线版本<br/>
   * 对接人： fangchangquan
   * @method ksBridge.getLocation
   * @category System
   * @version >=1.0.6
   * @example ./apis/system/getLocation.demo
   * @demo system/getLocation
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   *
   * ```
   * {
   *     result: 1,
   *     data: {
   *         latitude: 40.008365156510884,
   *         longitude: 116.34678248968665,
   *     }
   * }
   * ```
   */
  getLocation: true
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_sniff__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 检查是否安装某个客户端<br />
   * 对应native接口：hasInstalledApp<br/>
   * 对接人： songyunlu
   * @method ksBridge.hasInstalledApp
   * @category System
   * @version >=1.0.0
   * @example ./apis/system/hasInstalledApp.demo
   * @demo system/hasInstalledApp
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | identifier | String | 应用名称或包名，Android 填包名，iOS 填 scheme【对于 iOS，待检查的客户端的 scheme 需要在白名单中，可找gaoke确认添加】 | √ | 常用参数 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * identifier 参数补充说明：
   * 检查是否安装微信或支付宝时，无论 iOS 还是 Android，identifier 只需传 wechat 或 alipay
   * ks-bridge 内部针对 Android 平台，会自动将其映射到 com.tencent.mm 或 com.eg.android.AlipayGphone
   *
   * 返回参数：
   * 
   * ```
   * {
   *     result: 1, // 1为已安装
   * }
   * ```
   */
  hasInstalledApp: {
    optHandle: function optHandle(opt) {
      var identifier = opt.identifier || '';

      if (__WEBPACK_IMPORTED_MODULE_0__lib_sniff__["a" /* default */].isAndroid) {
        switch (identifier) {
          case 'wechat':
            identifier = 'com.tencent.mm';
            break;

          case 'alipay':
            identifier = 'com.eg.android.AlipayGphone';
            break;
        }
      }

      opt.identifier = identifier;
      return opt;
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 打开本地安装的某个app<br />
   * 使用场景：在客户端中唤起第三方的客户端，仅 Android 支持，iOS 可以考虑通过 scheme 打开<br/>
   * 对应native接口：launchApp<br/>
   * 支持版本：客户端18年07月初上线版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.launchApp
   * @category System
   * @version >=1.0.0
   * @example ./apis/system/launchApp.demo
   * @demo system/launchApp
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | identifier | String | 应用名称或包名 | √ | 常用参数 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 无意义
   *     result: 1
   * }
   * ```
   */
  launchApp: true
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 向客户端发送免流状态更新事件<br />
   * 对应native接口：emitFreeTrafficUpdate<br/>
   * 支持版本：客户端预计18年-01月底上线版本，有更新<br/>
   * 对接人： songyunlu
   * @method ksBridge.emitFreeTrafficUpdate
   * @category System
   * @version >=1.0.0
   * @example ./apis/system/emitFreeTrafficUpdate.demo
   * @demo system/emitFreeTrafficUpdate
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | 常用参数 |
   * | fail | Function | 失败回调函数 | X | 常用参数 |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  emitFreeTrafficUpdate: true
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取设备加密信息<br/>
   * 对应native接口：getDeviceSecretInfo<br/>
   * 对接人：lifang<br/>
   * @method ksBridge.getDeviceSecretInfo
   * @category System
   * @version >=1.0.10
   * @example ./apis/system/getDeviceSecretInfo.demo
   * @demo system/getDeviceSecretInfo
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   **/
  getDeviceSecretInfo: true
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 扫描条形码<br/>
   * 对应native接口：scanCode<br/>
   * 对接人：chenyuzhe<br/>
   * @method ksBridge.scanCode
   * @category System
   * @version >=1.0.12
   * @example ./apis/system/scanCode.demo
   * @demo system/scanCode
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | scene | String | 业务场景 | X | 数据上报用 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  scanCode: true
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 复制到剪贴板<br/>
   * 对应native接口：setClipBoard<br/>
   * 对接人：chenyuzhe<br/>
   * @method ksBridge.setClipBoard
   * @category System
   * @version >=1.0.12
   * @example ./apis/system/setClipBoard.demo
   * @demo system/setClipBoard
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | text | String | 复制的内容 | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  setClipBoard: true
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取已安装app的版本信息.仅Android支持<br/>
   * 对应native接口：installedAppVersion<br/>
   * 对接人：xinyangxi<br/>
   * @method ksBridge.installedAppVersion
   * @category System
   * @version >=1.0.13
   * @example ./apis/system/installedAppVersion.demo
   * @demo system/installedAppVersion
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | identifier | string | android包名 | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 返回参数：
   * 
   * ```
   * {
   *     result: 1,
   *     appVersion: '7.0.3'
   * }
   * ```
   **/
  installedAppVersion: true
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取夜间模式<br/>
   * 对应native接口：getDarkMode<br/>
   * 对接人：yinyong<br/>
   * @method ksBridge.getDarkMode
   * @category System
   * @version >=2.0.1
   * @example ./apis/system/getDarkMode.demo
   * @demo system/getDarkMode
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 返回参考：
   * 
   * ```json
   * {
   *     "result": 1,
   *     "darkMode": true
   * }
   * ```
   * 目前主站深色模式灰度中，未命中的，即使系统已开启深色模式，darkMode 仍为 false，如需测试，测试包摇一摇 abTest 下有相应开关
   * 
   * 另外一种同步获取夜间模式的方法是读取名为“darkMode”的cookie，其值为“true”或者“false”。为确保cookie存在，可自行调用injectCookie方法。
   **/
  getDarkMode: true
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 以系统浏览器方式打开某链接<br/>
   * 对应native接口：openBrowser<br/>
   * 对应版本：7.6.50 及以上版本<br/>
   * 对接人：xinyangxi<br/>
   * @method ksBridge.openBrowser
   * @category System
   * @version >=2.0.1
   * @example ./apis/system/openBrowser.demo
   * @demo system/openBrowser
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | url | String| 要打开的链接url（必须http(s)开头 ） | √ |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  openBrowser: true
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPageTitle__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setStatusBarStyle__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setPhysicalBackButton__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__showToast__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__showDialog__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__showAlertDialog__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__showConfirmDialog__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resetTopButtons__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__showBottomSheet__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__setTopLeftBtn__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__setTopLeftSecondBtn__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__setTopRightBtn__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__setTopRightSecondBtn__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__showPicker__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collapseKeyboard__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__businessAction__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hideNavigationBar__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__popupToFollow__ = __webpack_require__(104);



















var ui = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_18__popupToFollow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__hideNavigationBar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__businessAction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__collapseKeyboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__setPageTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__setTopLeftBtn__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__setTopLeftSecondBtn__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__setTopRightBtn__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__setTopRightSecondBtn__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__resetTopButtons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__setPhysicalBackButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__showToast__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__showDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__showAlertDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__showConfirmDialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__showBottomSheet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__showPicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__setStatusBarStyle__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  ui: ui
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置 title<br />
   * 对应native接口：setPageTitle<br/>
   * 注意：UI接口访问时不限制域名<br/>
   * 对接人： songyunlu
   * @method ksBridge.setPageTitle
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setPageTitle.demo
   * @demo ui/setPageTitle
   * @description
   *
   * titleTextColor、titleBackgroundColor 新增参数，仅支持完整的16进制颜色色值（即#rrggbb 格式），双端 7.3.40 及以上版本支持
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 标题 | √ | - |
   * | titleTextColor | String | 标题颜色 | X | - |
   * | titleBackgroundColor | String | 标题栏背景色 | X | - |
   * 
   */
  setPageTitle: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置电池栏图标文字颜色<br />
   * 对应native接口：setStatusBarStyle<br/>
   * 注意：Android 系统 5.x 以上电池栏背景色是透明的，5.x 及以下版本不支持沉浸式，电池栏背景色固定是黑色<br/>
   * 对接人： songyunlu
   * @method ksBridge.setStatusBarStyle
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setStatusBarStyle.demo
   * @demo ui/setStatusBarStyle
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | style | Number | 状态栏文字颜色, 0：黑色，1: 白色，不支持自定义颜色 | √ | - |
   */
  setStatusBarStyle: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 安卓返回按钮事件绑定<br />
   * 对应native接口：setPhysicalBackButton<br/>
   * 注意：仅支持 Android<br/>
   * 对接人： songyunlu
   * @method ksBridge.setPhysicalBackButton
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setPhysicalBackButton.demo
   * @demo ui/setPhysicalBackButton
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | onClick | Function | 按钮点击事件回调 | √ | - |
   */
  setPhysicalBackButton: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* generateUUCallbackFunction */])('setPhysicalBackButton', opt.onClick, true)
      });
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 显示 toast<br />
   * 对应native接口：showToast<br/>
   * 对接人： songyunlu
   * @method ksBridge.showToast
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/showToast.demo
   * @demo ui/showToast
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | String | toast类型，normal(灰色)，success(绿色)，error(红色) | √ | - |
   * | text | String | toast 内容 | √ | text文案长度超过7个字符将不显示icon |
   */
  showToast: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_extend__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 显示提示框<br />
   * 对应native接口：showDialog<br/>
   * 注意：请不要单独使用 negativeButton、neutralButton 或 positiveButton+neutralButton、negativeButton+neutralButton 组合使用，否则会导致 app 崩溃<br/>
   * 对接人： songyunlu
   * @method ksBridge.showDialog
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/showDialog.demo
   * @demo ui/showDialog
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 提示框标题 | X | - |
   * | content | String | 提示框内容 | √ | - |
   * | positiveButton | Object | 确认按钮设置 | ？ | 参见示例代码 |
   * | negativeButton | Object | 取消按钮设置 | X | 参见示例代码 |
   * | neutralButton | Object | ? | X | 参见示例代码 |
   */
  showDialog: {
    key: 'showDialog',
    optHandle: function optHandle(opt) {
      var tmp = {
        notPromise: true
      };
      tmp = Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])(true, tmp, opt);
      var _tmp = tmp,
          positiveButton = _tmp.positiveButton,
          negativeButton = _tmp.negativeButton,
          neutralButton = _tmp.neutralButton;

      if (positiveButton) {
        tmp.positiveButton = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* transformFuncToURL */])('showDialog', positiveButton);
      }

      if (negativeButton) {
        tmp.negativeButton = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* transformFuncToURL */])('showDialog', negativeButton);
      }

      if (neutralButton) {
        tmp.neutralButton = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* transformFuncToURL */])('showDialog', neutralButton);
      }

      return tmp;
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_extend__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 显示提示框<br />
   * 对应native接口：showDialog<br/>
   * 注意：基于 showDialog 组件进行的二次封装，简化调用<br/>
   * 对接人： songyunlu
   * @method ksBridge.showAlertDialog
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/showAlertDialog.demo
   * @demo ui/showAlertDialog
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 提示框标题 | X | - |
   * | content | String | 提示框内容 | √ | - |
   * | confirmBtnText | String | 确定按钮文案，默认为 '确定' | X | - |
   * | onConfirm | Function | 确认回调事件 | √ | - |
   */
  showAlertDialog: {
    key: 'showDialog',
    optHandle: function optHandle(opt) {
      var tmp = {
        notPromise: true,
        title: '',
        content: '',
        confirmBtnText: '确定',
        onConfirm: function onConfirm() {}
      };
      tmp = Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])(true, tmp, opt);
      return {
        title: tmp.title,
        content: tmp.content,
        positiveButton: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* transformFuncToURL */])('showAlertDialog', {
          text: tmp.confirmBtnText,
          actions: [{
            actionType: 'JS_CALLBACK',
            url: tmp.onConfirm
          }]
        })
      };
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_extend__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 显示提示框<br />
   * 对应native接口：showDialog<br/>
   * 注意：基于 showDialog 组件进行的二次封装，简化调用<br/>
   * 对接人： songyunlu
   * @method ksBridge.showConfirmDialog
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/showConfirmDialog.demo
   * @demo ui/showConfirmDialog
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 提示框标题 | X | - |
   * | content | String | 提示框内容 | √ | - |
   * | confirmBtnText | String | 确定按钮文案，默认为 '确定' | X | - |
   * | cancelBtnText | String | 取消按钮文案，默认为 '取消' | X | - |
   * | onConfirm | Function | 确认回调事件 | √ | - |
   * | onCancel | Function | 取消回调事件 | √ | - |
   */
  showConfirmDialog: {
    key: 'showDialog',
    optHandle: function optHandle(opt) {
      var tmp = {
        notPromise: true,
        title: '',
        content: '',
        confirmBtnText: '确定',
        cancelBtnText: '取消',
        onConfirm: function onConfirm() {},
        onCancel: function onCancel() {}
      };
      tmp = Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])(true, tmp, opt);
      return {
        title: tmp.title,
        content: tmp.content,
        cancelable: tmp.cancelable,
        positiveButton: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* transformFuncToURL */])('showConfirmDialog', {
          text: tmp.confirmBtnText,
          actions: [{
            actionType: 'JS_CALLBACK',
            url: tmp.onConfirm
          }]
        }),
        negativeButton: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* transformFuncToURL */])('showConfirmDialog', {
          text: tmp.cancelBtnText,
          actions: [{
            actionType: 'JS_CALLBACK',
            url: tmp.onCancel
          }]
        })
      };
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 重设顶部nav bar的按钮状态<br />
   * 对应native接口：resetTopButtons<br/>
   * 支持版本：客户端18.05月版本<br/>
   * 对接人： songyunlu
   * @method ksBridge.resetTopButtons
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/resetTopButtons.demo
   * @demo ui/resetTopButtons
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   */
  resetTopButtons: true
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 显示底部ActionSheet<br />
   * 对应native接口：showBottomSheet<br/>
   * 注意：Native 固定添加取消操作，点击取消回调无value<br/>
   * 对接人： songyunlu
   * @method ksBridge.showBottomSheet
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/showBottomSheet.demo
   * @demo ui/showBottomSheet
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 标题 | √ | - |
   * | options | Object | 选项，对象数组 | √ | 例如 { text: '1', value: 1, type: 0 } |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 返回参数：
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   *     // 选项的value值
   *     value: ''
   * }
   * ```
   */
  showBottomSheet: true
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置顶部左侧按钮<br />
   * 对应native接口：setTopLeftBtn<br/>
   * 注意：不调用时默认为back类型, 每次打开页面时使用默认配置, 不使用上个页面的配置<br/>
   * 对接人： songyunlu
   * @method ksBridge.setTopLeftBtn
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setTopLeftBtn.demo
   * @demo ui/setTopLeftBtn
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | show | Bool | 是否显示 | √ | - |
   * | icon | String | wallet，back，camera，chat，close，edit，question，info，more，refresh，share，custom，done，可选，默认为 back | X | iOS: 支持icon和text同时设置，Android: 存在icon时使用icon, 否则使用text |
   * | iconUrl | Object | icon为custom是，指定图片url，{ normal: '默认按钮图片url', pressed: '点击时按钮图片url，未设置时使用normal的设置' } | X | - |
   * | text | String | 可为空 | X | - |
   * | textColor | String | 文字颜色, 仅作用于text类button | X | - |
   * | onClick | Function | 按钮点击事件回调 | X | - |
   * 
   * 注意：
   * 在 Android 5 且设置 layoutType=4 时，沉浸式有兼容问题，导航条虽然隐藏但是会盖在 h5 上面，导致导航栏位置点击不响应，可以考虑使用 hideNavigationBar 隐藏
   */
  setTopLeftBtn: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* generateUUCallbackFunction */])('setTopLeftBtn', opt.onClick, true)
      });
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置左侧第二个按钮<br />
   * 对应native接口：setTopLeftSecondBtn<br/>
   * 对接人： songyunlu
   * @method ksBridge.setTopLeftSecondBtn
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setTopLeftSecondBtn.demo
   * @demo ui/setTopLeftSecondBtn
   * @description
   *
   * 调用参数：
   * 与 setTopLeftBtn 相同
   * **android 平台仅在广告详情页可用**
   */
  setTopLeftSecondBtn: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* generateUUCallbackFunction */])('setTopLeftSecondBtn', opt.onClick, true)
      });
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置顶部右侧按钮<br />
   * 对应native接口：setTopRightBtn<br/>
   * 注意：不调用时默认为back类型, 每次打开页面时使用默认配置, 不使用上个页面的配置<br/>
   * 对接人： songyunlu
   * @method ksBridge.setTopRightBtn
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setTopRightBtn.demo
   * @demo ui/setTopRightBtn
   * @description
   *
   * 调用参数：
   * 与 setTopLeftBtn 相同
   */
  setTopRightBtn: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* generateUUCallbackFunction */])('setTopRightBtn', opt.onClick, true)
      });
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置右侧第二个按钮<br />
   * 对应native接口：setTopRightSecondBtn<br/>
   * 对接人： songyunlu
   * @method ksBridge.setTopRightSecondBtn
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/setTopRightSecondBtn.demo
   * @demo ui/setTopRightSecondBtn
   * @description
   *
   * 注意：
   * iOS yoda 容器中，需要单独给 icon 字段设置为 none【否则会多个✅图标，安卓不影响】
   * 
   * 调用参数：
   * 与 setTopLeftBtn 相同
   */
  setTopRightSecondBtn: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* generateUUCallbackFunction */])('setTopRightSecondBtn', opt.onClick, true)
      });
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 通用单选组件<br />
   * 对应native接口：showPicker<br/>
   * 对接人： songyunlu
   * @method ksBridge.showPicker
   * @category UI
   * @version >=1.0.0
   * @example ./apis/ui/showPicker.demo
   * @demo ui/showPicker
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | param | Object | picker 内容配置 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 返回参数：
   * ```
   * {
   *     // 1成功 0用户取消
   *     result: 1,
   *     error_msg: '',
   *     data: {
   *         // selectedData是个数组，分别是选中的第一列的值，第二列的值，第三列的值
   *         selectedData: [
   *             { //选中的第一列的值
   *                 text: '',
   *                 id: ''
   *             },
   *             { //选中的第二列的值
   *                 text: '',
   *                 id: ''
   *             }
   *         ]
   *     }
   * }
   * ```
   */
  showPicker: true
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 收起软键盘<br/>
   * 对应native接口：collapseKeyboard<br/>
   * 对接人：zhengmeiyu<br/>
   * @method ksBridge.collapseKeyboard
   * @category UI
   * @version >=1.0.4
   * @example ./apis/ui/collapseKeyboard.demo
   * @demo ui/collapseKeyboard
   **/
  collapseKeyboard: {
    optHandle: function optHandle() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 唤起native时间控件<br/>
   * 对应native接口：businessAction<br/>
   * 对接人：liguohui<br/>
   * @method ksBridge.businessAction
   * @category UI
   * @version >=1.0.16
   * @example ./apis/ui/businessAction.demo
   * @demo ui/businessAction
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | String | bridge名称 | true | LaunchDatePicker |
   * | data | JSON | 相关参数 | true | - |
   * | complete | Function | 结束回调| false | - |
   * 
   * data内容：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | datePickerInfo | Object | 参数容器 | true ||
   * 
   * datePickerInfo内容：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | title | String | 标题| true ||
   * | startTimestamp | Number | 可选范围开始时间| false |时间戳ms|
   * | endTimestamp | Number | 可选范围结束时间 | false |时间戳ms|
   * | defaultTimestamp | Number | 默认时间 | false |时间戳ms|
   **/
  businessAction: true
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 隐藏导航栏区域，对所有layoutType生效<br/>
   * 对应native接口：hideNavigationBar<br/>
   * 对接人：lianxin<br/>
   * @method ksBridge.hideNavigationBar
   * @category UI
   * @version >=1.0.16
   * @example ./apis/ui/hideNavigationBar.demo
   * @demo ui/hideNavigationBar
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  hideNavigationBar: true
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 弹出关注弹窗<br/>
   * 对应native接口：popupToFollow<br/>
   * 对接人：houjia<br/>
   * @method ksBridge.popupToFollow
   * @category UI
   * @version >=2.0.2
   * @example ./apis/ui/popupToFollow.demo
   * @demo ui/popupToFollow
   * @description 
   * 
   * * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | userAvatar | String | 用户头像 | √ | - |
   * | userName | String | 用户名 | √ | - |
   * | fansCount | String | 粉丝数 | √ | - |
   * | recommendReason | String | 推荐理由 | √ | - |
   * | userId | Number | 用户id | √ | - |
   * | followReferStack | String | 关注来源 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 
   * [购买成功推荐关注](https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=634623648)
   * 
   * ``` json
   *     {
   * 	"result": 0, 
   * 	"data":{
   * 		"code":1
   * 	}
   *     }
   * ```
   * 
   * * result定义：  
   *     // -1:native执行失败；  
   *     //  1：native执行成功  
   *     
   * * code 取值定义：  
   *     // -1: 关注失败；  
   *     //  1: 弹窗曝光  
   *     //  2: 点击关闭按钮  
   *     //  4: 点击关注按钮  
   *     //  5: 关注成功
   **/
  popupToFollow: true
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loadUrlOnNewPage__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__joinGroup__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setSlideBack__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setMiddleSlideBack__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__popBack__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exitWebView__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exitCurrentWebview__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setBounceStyle__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__openYodaPage__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loadUrlOnNewFansTopPage__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__exitAll__ = __webpack_require__(116);












var webview = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_11__exitAll__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__loadUrlOnNewFansTopPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__openYodaPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__setBounceStyle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__exitCurrentWebview__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__popBack__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__exitWebView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__loadUrlOnNewPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__joinGroup__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__setMiddleSlideBack__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__setSlideBack__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  webview: webview
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 打开新的 webview<br />
   * 对应native接口：loadUrlOnNewPage<br/>
   * 对接人： songyunlu
   * @method ksBridge.loadUrlOnNewPage
   * @category WebView
   * @version >=1.0.0
   * @example ./apis/webview/loadUrlOnNewPage.demo
   * @demo webview/loadUrlOnNewPage
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | url | String | 新打开的页面的 URL 地址 | √ | 常用参数 |
   * | type | String | 类型？ | √ | 常用参数，值可选 'close' 或 'back' |
   *
   */
  loadUrlOnNewPage: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 调起bridge加入群聊<br />
   * 对应native接口：joinGroup<br/>
   * 对接人： hanchen
   * @method ksBridge.joinGroup
   * @category WebView
   * @version >=1.0.1
   * @example ./apis/webview/joinGroup.demo
   * @demo webview/joinGroup
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | groupid | String | 群聊id | √ | - |
   * | signData | String | 标识群聊分享信息的签名 | √ | - |
   * | inviterid | String | 邀请人id | √ | - |
   * | closeWebViewOnSuccess | Bool | 是否在成功调起bridge后关闭当前页面webview | X | 默认值：true |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  joinGroup: true
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置页面是否开启滑动返回<br />
   * 对应native接口：setSlideBack<br/>
   * 注意：控制不能???<br/>
   * 对接人： songyunlu
   * @method ksBridge.setSlideBack
   * @category WebView
   * @version >=1.0.0
   * @example ./apis/webview/setSlideBack.demo
   * @demo webview/setSlideBack
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | enabled | Bool | 是否开启 | √ | - |
   *
   */
  setSlideBack: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置页面中部滑动返回功能<br />
   * 对应native接口：setMiddleSlideBack<br/>
   * 注意：边缘返回不受控制，仅 iOS 支持<br/>
   * 对接人： songyunlu
   * @method ksBridge.setMiddleSlideBack
   * @category WebView
   * @version >=1.0.0
   * @example ./apis/webview/setMiddleSlideBack.demo
   * @demo webview/setMiddleSlideBack
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | enabled | Bool | 打开滑动返回，false关闭滑动返回 | √ | - |
   *
   */
  setMiddleSlideBack: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 退出<br />
   * 对应native接口：popBack<br/>
   * 注意：如果当前是第一个，就退出webview，否则就history.back()<br/>
   * 对接人： songyunlu
   * @method ksBridge.popBack
   * @category WebView
   * @version >=1.0.0
   * @example ./apis/webview/popBack.demo
   * @demo webview/popBack
   * @description
   * 
   */
  popBack: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        // 因为这种参数约定不规范的约定太恶心
        // 所以我决定用这个恶心的使用方式来强烈提示
        // 一定要规范定义和native的交互参数
        // 这两个桥不需要参数
        '__self__': false
      });
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 退出当前web page<br />
   * 对应native接口：exitWebView<br/>
   * 注意：ios如果不在当前webview, exitWebview可能会失效<br/>
   * 对接人： songyunlu
   * @method ksBridge.exitWebView
   * @category WebView
   * @version >=1.0.0
   * @example ./apis/webview/exitWebView.demo
   * @demo webview/exitWebView
   */
  exitWebView: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        // 因为这种参数约定不规范的约定太恶心
        // 所以我决定用这个恶心的使用方式来强烈提示
        // 一定要规范定义和native的交互参数
        // 这两个桥不需要参数
        '__self__': false
      });
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 关闭执行该代码的webview<br/>
   * 对应native接口：exitCurrentWebview<br/>
   * 对接人：leijie<br/>
   * @method ksBridge.exitCurrentWebview
   * @category WebView
   * @version >=1.0.16
   * @example ./apis/webview/exitCurrentWebview.demo
   * @demo webview/exitCurrentWebview
   * @description 
   * 
   * 作用与 exitWebView 类似
   * 
   * 使用场景：当前 h5 页面将打开一个 native 页，同时需要关闭当前 h5 页面时，Android 调用 exitWebView，iOS 使用 exitCurrentWebview 即可。
   * 
   * 新增 exitCurrentWebview 的原因是因为 iOS 端调用 exitWebView 会关闭路由堆栈最顶上的页面，即新开的 native 页，考虑改动 exitWebView 影响范围过大，故新增 exitCurrentWebview 支持
   * 
   * 具体使用可以参考「leijie」封装的模块：http://git.corp.kuaishou.com/leijie/ks-exitwebview，有相关问题可联系 leijie
   **/
  exitCurrentWebview: true
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置页面上下拉回调效果(仅iOS)，最低版本6.10.4<br/>
   * 对应native接口：setBounceStyle<br/>
   * 对接人：songyunlu<br/>
   * @method ksBridge.setBounceStyle
   * @category WebView
   * @version >=1.0.16
   * @example ./apis/webview/setBounceStyle.demo
   * @demo webview/setBounceStyle
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | enable | boolean | 是否允许页页上拉下滑，默认为true | Y | 仅iOS生效，安卓都是关闭状态 |
   **/
  setBounceStyle: true
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 用 yoda webview 打开页面<br />
   * 对应native接口：openYodaPage<br/>
   * 注意：不推荐使用，请直接使用 loadUrlOnNewPage<br/>
   * 对接人： fangchangquan
   * @method ksBridge.openYodaPage
   * @category WebView
   * @version >=1.0.18
   * @example ./apis/webview/openYodaPage.demo
   * @demo webview/openYodaPage
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | bizId | String | bizId有对应的url和launchOptions，如果继续传url和launchOptions则会覆盖bizId中相应的配置建议传了bizId就不要传url和launchOption，防止后续更新线上配置不能影响到这里 | X | - |
   * | url | String | 新打开的页面的 URL 地址，指定了bizId 可为空 | √ | 常用参数 |
   * | launchOptions | Object | webview 相关的配置，参考http://zt.corp.kuaishou.com/user/document/detail?serviceId=8&portalType=1&docId=113 | X | - |
   * | data | Object | 携带给新 webview 的数据,可以被 yoda 的 getLaunchParams bridge 获取 | X | - |
   *
   */
  openYodaPage: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 在非粉条H5中新打开粉条WebView（仅iOS支持）<br/>
   * 对应native接口：loadUrlOnNewFansTopPage<br/>
   * 对接人：zhaoyang03<br/>
   * @method ksBridge.loadUrlOnNewFansTopPage
   * @category WebView
   * @version >=2.0.1
   * @example ./apis/webview/loadUrlOnNewFansTopPage.demo
   * @demo webview/loadUrlOnNewFansTopPage
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | url | String | 打开新的H5链接 | √ | - |
   * | type| String | 类型 | √ | 常用参数，值可选 'close' 或 'back'|
   **/
  loadUrlOnNewFansTopPage: true
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 退出所有webview（仅iOS支持）<br/>
   * 对应native接口：exitAll<br/>
   * 对接人：zhaoyang03<br/>
   * @method ksBridge.exitAll
   * @category WebView
   * @version >=2.0.1
   * @example ./apis/webview/exitAll.demo
   * @demo webview/exitAll
   * @description 
   * 
   **/
  exitAll: true
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__on__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addEventListener__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__off__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__removeEventListener__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emit__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatchEvent__ = __webpack_require__(123);







var event = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_1__on__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__addEventListener__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__off__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__removeEventListener__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__emit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__dispatchEvent__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  event: event
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 监听事件<br />
   * 使用场景：页面监听一个事件，由客户端触发或前端通过 emit 方法来触发事件回调<br/>
   * 注意：on、off 方法指定回调 handler 时，使用方式与 addEventListener、removeEventListener 类似，不能传匿名函数<br/>
   * 对应native接口：on<br/>
   * 对接人： fangchangquan
   * @method ksBridge.on
   * @category Event
   * @version >=1.0.0
   * @example ./apis/event/on.demo
   * @demo event/on
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | String | 事件名称，支持客户端定义的事件，也可以自定义 | √ | 客户端定义的事件详见下文 |
   * | handler | Function | type 对应的事件的回调 | √ | - |
   * | success | Function | on 调用的成功回调 | X | - |
   * | fail | Function | on 调用的失败回调 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * | type | 可能的 value | 解释 | 备注 |
   * | :--: | :--: | :--: |:--: |
   * | native_pageFinished |  | 加载页面完毕 |  |
   * | native_background |  | 进入后台 |  |
   * | native_foreground |  | 进入前台 |  |
   * | native_leave |  | 切换到App内其它页面（or webview） |  |
   * | native_reentry |  | 从其他页面（or webview）切换回来 |  |
   * | native_loadPage |  | 在当前webview打开新页面 |  |
   * | h5_XXXXXXX |  | 由不同webview之间发起和处理的事件，需要H5_前缀 |  |
   *
   * 返回参数：
   *
   * on 调用的回调:
   * ```
   * {
   *     result: 1
   * }
   * ```
   *
   * handler:
   * 具体的值根据触发事件时回传的数据来定，数据类型与 emit 回传的数据类型一致。
   * ```
   * {
   *     key: 'value'
   * }
   * ```
   */
  on: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        handler: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* generateHandlerFunction */])('on', opt.handler)
      });
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 监听事件<br />
   * 使用场景：监听事件<br/>
   * 对应native接口：on<br/>
   * 对接人： fangchangquan
   * @method ksBridge.addEventListener
   * @category Event
   * @version >=2.0.0
   * @example ./apis/event/addEventListener.demo
   * @demo event/addEventListener
   * @description
   * 
   * 注意：
   * 调用方式与 on 一样
   * 
   * 与 on 的区别：
   * 在主 APP 旧容器中实际是使用 on bridge 进行事件监听，在 yoda 容器中，使用 yoda.event.addEventListener 进行监听
   * 所以使用该方法监听事件时，需要保证该事件在两个 webview 中支持，目前仅支持 data-fetch-change 事件
   */
  addEventListener: {
    key: 'on',
    // 适配 yoda webview 下 event.addEventListener bridge
    yodaBridge: {
      namespace: 'event',
      bridge: 'addEventListener'
    },
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        handler: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* generateHandlerFunction */])('addEventListener', opt.handler)
      });
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 解绑事件<br />
   * 注意：on、off 方法指定回调 handler 时，使用方式与 addEventListener、removeEventListener 类似，不能传匿名函数<br/>
   * 对应native接口：off<br/>
   * 对接人： fangchangquan
   * @method ksBridge.off
   * @category Event
   * @version >=1.0.0
   * @example ./apis/event/off.demo
   * @demo event/off
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | String | 事件名称，支持客户端定义的事件，也可以自定义 | X | 客户端事件请查阅 on 方法相关说明 |
   * | handler | Function | type 对应的事件的回调 | X | 解绑 handler 需要与调用 on 监听时传的 handler 为同一个回调 |
   * | success | Function | on 调用的成功回调 | X | - |
   * | fail | Function | on 调用的失败回调 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * off 解绑规则：
   * 如果只有type存在，则解绑该type下所有handler，如果只有handler存在，则解绑所有type下的该handler，
   * 如果type，handler都有， 则只解绑该type下的该handler；如果type，handler都不存在， 则清除所有通过on绑定的事件
   */
  off: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        handler: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* generateHandlerFunction */])('off', opt.handler)
      });
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 解绑事件<br />
   * 使用场景：解绑事件监听<br/>
   * 对应native接口：off<br/>
   * 对接人： fangchangquan
   * @method ksBridge.removeEventListener
   * @category Event
   * @version >=2.0.0
   * @example ./apis/event/removeEventListener.demo
   * @demo event/removeEventListener
   * @description
   * 
   * * 注意：
   * 调用方式与 off 一样
   * 
   * 与 off 的区别：
   * 在主 APP 旧容器中实际是使用 off bridge 进行事件解除监听，在 yoda 容器中，使用 yoda.event.removeEventListener 进行监听
   * 所以使用该方法解除监听事件时，需要保证该事件在两个 webview 中支持，目前仅支持 data-fetch-change 事件
   * 
   */
  removeEventListener: {
    key: 'off',
    // 适配 yoda webview 下 event.removeEventListener bridge
    yodaBridge: {
      namespace: 'event',
      bridge: 'removeEventListener'
    },
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        handler: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* generateHandlerFunction */])('removeEventListener', opt.handler)
      });
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 发送一个事件，与 on 方法配合使用<br />
   * 对应native接口：emit<br/>
   * 对接人： fangchangquan
   * @method ksBridge.emit
   * @category Event
   * @version >=1.0.0
   * @example ./apis/event/emit.demo
   * @demo event/emit
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | String | 事件名称 | √ | 客户端事件请查阅 on 方法相关说明 |
   * | data | Object/String | 回传的数据 | √ | - |
   * | success | Function | 成功回调 | X | - |
   * | fail | Function | 失败回调 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  emit: {
    optHandle: function optHandle(opt) {
      if (opt && _typeof(opt.data) === 'object' && opt.data !== null) {
        opt.data = JSON.stringify(opt.data);
      }

      opt.notPromise = true;
      return opt;
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 发送一个事件，与 addEventListener 方法配合使用<br />
   * 对应native接口：emit<br/>
   * 对接人： fangchangquan
   * @method ksBridge.dispatchEvent
   * @category Event
   * @version >=1.0.0
   * @example ./apis/event/dispatchEvent.demo
   * @demo event/dispatchEvent
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | type | String | 事件名称 | √ | 客户端事件请查阅 on 方法相关说明 |
   * | data | Object | 回传的数据 | √ | - |
   * | success | Function | 成功回调 | X | - |
   * | fail | Function | 失败回调 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   */
  dispatchEvent: {
    key: 'emit',
    yodaBridge: {
      namespace: 'event',
      bridge: 'dispatchEvent'
    },
    optHandle: function optHandle(opt) {
      if (!__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda && opt && _typeof(opt.data) === 'object' && opt.data !== null) {
        opt.data = JSON.stringify(opt.data);
      }

      opt.notPromise = true;
      return opt;
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploadIntownVideo__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__previewIntownVideo__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reuploadIntownVideo__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intownShare__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accessIntownInfo__ = __webpack_require__(129);






var intown = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_1__uploadIntownVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__previewIntownVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__reuploadIntownVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__intownShare__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__accessIntownInfo__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  intown: intown
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 同乡拍摄并上传视频<br />
   * 对应native接口：uploadIntownVideo<br/>
   * 注意：回调多次，前端可根据 progress 显示上传进度<br/>
   * 对接人： miaowei
   * @method ksBridge.uploadIntownVideo
   * @category Intown
   * @version >=1.0.0
   * @example ./apis/intown/uploadIntownVideo.demo
   * @demo intown/uploadIntownVideo
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 1: 正常; 0: 取消; 其他: 失败/异常
   *     result: 1,
   *     data: {
   *         // 用于预览、重传
   *         uploadId: '94015796-3862-483E-9EA6-FB053D6667B3',
   *         // 视频封面 url，progress 为 100 时才有
   *         coverUrl: 'http://ali2.a.yximgs.com/bs2/intownImage/MjAyMTY_o.jpg',
   *         coverKey: '1531293052316_qUkZkqISQ9qv4QLIVI600ssoq',
   *         // 视频 url，progress 为 100 时才有
   *         videoUrl: 'http://ali2.a.yximgs.com/bs2/intownVideo/MjAyMTY.mp4',
   *         // 进度
   *         progress: '100',
   *         // 用于预览、重传
   *         filePath: '/var/mobile/Containers/Data/Application/27B876FE-7014-4ED2-9A21-D6943CBEA61F/Documents/gifs/152B184D-C134-4B06-B009-F5813AC46EA8.MOV',
   *         photoId': '5xwyk9vaarq9w6u'
   *     }
   * }
   * ```
   */
  uploadIntownVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 同乡视频预览<br />
   * 对应native接口：previewIntownVideo<br/>
   * 注意：没有回调<br/>
   * 对接人： miaowei
   * @method ksBridge.previewIntownVideo
   * @category Intown
   * @version >=1.0.0
   * @example ./apis/intown/previewIntownVideo.demo
   * @demo intown/previewIntownVideo
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | uploadId | String | uploadIntownVideo 方法返回的 uploadId | √ | - |
   * | filePath | String | uploadIntownVideo 方法返回的 filePath | √ | - |
   *
   */
  previewIntownVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 同乡视频预览<br />
   * 对应native接口：reuploadIntownVideo<br/>
   * 对接人： miaowei
   * @method ksBridge.reuploadIntownVideo
   * @category Intown
   * @version >=1.0.0
   * @example ./apis/intown/reuploadIntownVideo.demo
   * @demo intown/reuploadIntownVideo
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | uploadId | String | uploadIntownVideo 方法返回的 uploadId | √ | - |
   * | filePath | String | uploadIntownVideo 方法返回的 filePath | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 返回参数：
   * 与**uploadIntownVideo**一样，详见**uploadIntownVideo**
   */
  reuploadIntownVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 同乡社交平台分享<br />
   * 对应native接口：intownShare<br/>
   * 对接人： miaowei
   * @method ksBridge.intownShare
   * @category Intown
   * @version >=1.0.0
   * @example ./apis/intown/intownShare.demo
   * @demo intown/intownShare
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | hideResultToast | Bool | 分享后是否显示  “分享成功”/“分享失败” 的 toast | X | 新增字段，具体可咨询chenxiaolong |
   * | param | Object | 分享设置，具体可查看示例代码 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 1: 正常; 0: 取消; 其他: 失败/异常
   *     result: 1
   * }
   * ```
   */
  intownShare: true
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 设置或者读取同乡信息<br />
   * 对应native接口：accessIntownInfo<br/>
   * 对接人： miaowei
   * @method ksBridge.accessIntownInfo
   * @category Intown
   * @version >=1.0.0
   * @example ./apis/intown/accessIntownInfo.demo
   * @demo intown/accessIntownInfo
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | intownInfo | String | 同乡信息，对象字符串？ | X | 设置信息时需要该字段，读取时不需要 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 1: 正常; 0: 取消; 其他: 失败
   *     result: 1,
   *     // 读取和设置都需要返回
   *     intownInfo : "{ \"intownId\": \"efa3r23\", \"mtime\": 123131231 }"
   * }
   * ```
   */
  accessIntownInfo: true
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startAuthActivity__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startThirdPartyPaymentForWebActivity__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__downloadThirdPartyAPP__ = __webpack_require__(133);




var third = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_1__startAuthActivity__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__startThirdPartyPaymentForWebActivity__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__downloadThirdPartyAPP__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  third: third
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 授权<br />
   * 对应native接口：startAuthActivity<br/>
   * 注意：仅 Android 支持<br />
   * 对接人： songyunlu
   * @method ksBridge.startAuthActivity
   * @category Third
   * @version >=1.0.0
   * @example ./apis/third/startAuthActivity.demo
   * @demo third/startAuthActivity
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | kwai_request_app_id | String | - | √ | - |
   * | kwai_request_type | String | - | √ | - |
   * | kwai_request_scope | String | - | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * 
   * 成功：
   * ```
   * {
   *     result: 1,
   *     kwai_response_open_id: '',
   *     kwai_response_code: '',
   *     kwai_response_access_token: ''
   * }
   * ```
   * 
   * 失败：
   * ```
   * {
   *     result: kwai_response_error_code,
   *     error_msg: kwai_response_error_msg
   * }
   * ```
   */
  startAuthActivity: true
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 支付<br />
   * 对应native接口：startThirdPartyPaymentForWebActivity<br/>
   * 注意：客户端将要下线，客户端将要下线，客户端将要下线，请不要再使用<br />
   * 对接人： songyunlu、zhangruifeng（客户端）
   * @method ksBridge.startThirdPartyPaymentForWebActivity
   * @category Third
   * @version >=1.0.0
   * @description
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | kwai_request_prepay_id | String | - | √ | - |
   * | kwai_order_id | String | - | √ | - |
   * | kwai_request_app_id | String | - | √ | - |
   * | kwai_request_sign | String | - | √ | - |
   * | kwai_request_timestamp | String | - | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * 
   * ```
   * {
   *     result: 1,
   *     error_msg: '',
   *     kwai_order_id: ''
   * }
   * ```
   */
  startThirdPartyPaymentForWebActivity: true
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 下载<br />
   * 对应native接口：downloadThirdPartyAPP<br/>
   * 注意：仅 Android 支持<br/>
   * 对接人： songyunlu
   * @method ksBridge.downloadThirdPartyAPP
   * @category Third
   * @version >=1.0.0
   * @example ./apis/third/downloadThirdPartyAPP.demo
   * @demo third/downloadThirdPartyAPP
   * @description
   *
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | action | String | 类型，start 重新开始 resume 继续或重新下载  pause 暂停 stop 停止 | √ | - |
   * | url | String | 下载地址 | √ | 使用 https 协议有问题 |
   * | fileType | String | 安卓上文件类型为video或image放在相册目录, 其它放在Download目录？ | X | - |
   * | photoId | Number | ? | X | - |
   * | clickType | Number | actionBar类型 | X | - |
   * | kwai_request_app_id | String | ? | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * 与**download**一致，请参考**download**的文档
   */
  downloadThirdPartyAPP: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploadShopVideo__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__previewVideo__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reuploadShopVideo__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merchantShare__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__querySessionIsStickyOnTop__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reqSessionStickyOnTopWithThread__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getSidToken__ = __webpack_require__(141);








var merchant = Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(true, __WEBPACK_IMPORTED_MODULE_7__getSidToken__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__reqSessionStickyOnTopWithThread__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__querySessionIsStickyOnTop__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__uploadShopVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__previewVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__reuploadShopVideo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__merchantShare__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  merchant: merchant
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 评价视频上传（支持拍摄，选择视频）<br />
   * 对应native接口：uploadShopVideo<br/>
   * 支持版本：android >= 6.3.2 ios >= 6.3.0<br/>
   * 注意：回调多次，前端可根据 progress 显示上传进度<br/>
   * 对接人： baiyunpeng
   * @method ksBridge.uploadShopVideo
   * @category Merchant
   * @version >=1.0.14
   * @example ./apis/merchant/uploadShopVideo.demo
   * @demo merchant/uploadShopVideo
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | taskId | String | 任务id | √ | 由特定接口下发 |
   * | token | String | 上传token | √ | 由特定接口下发 |
   * | coverUploadUrl | String | 上传封面图接口 | √ | 由特定接口下发 |
   * | endpointList | Array | 上传配置（客户端skd用） | √ | 由特定接口下发 |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 1: 正常; 0: 取消; 其他: 失败/异常
   *     result: 1,
   *     data: {
   *         // 用于预览、重传
   *         uploadId: '94015796-3862-483E-9EA6-FB053D6667B3',
   *         // 本地文件路径，用于预览视频
   *         filePath: '/var/mobile/Containers/Data/Application/27B876FE-7014-4ED2-9A21-D6943CBEA61F/Documents/gifs/152B184D-C134-4B06-B009-F5813AC46EA8.MOV',
   *         // 视频封面 base64值，用于预览展示（只有第一次回调返回，前端可直接使用）
   *         thumbnail: 'data:image/png:xxxxxxxxxxxxxxxxx',
   *         // 上传状态 success | fail
   *         status: 'success'
   *         // 进度 (进度100并且success的时候可判定上传成功)
   *         progress: '100',
   * 
   *     }
   * }
   * ```
   */
  uploadShopVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 评价视频预览<br />
   * 对应native接口：previewVideo<br/>
   * 注意：没有回调<br/>
   * 支持版本：android >= 6.3.2 ios >= 6.3.0<br/>
   * 对接人： baiyunpeng
   * @method ksBridge.previewVideo
   * @category Merchant
   * @version >=1.0.14
   * @example ./apis/merchant/previewVideo.demo
   * @demo merchant/previewVideo
   * @description
   *
   * 调用参数（优先使用filePath）：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | videoUrl | String | 视频cdn地址 | √ | - |
   * | filePath | String | uploadShopVideo 方法返回的 filePath | √ | - |
   *
   */
  previewVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true
      });
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 评价视频重传<br />
   * 对应native接口：reUploadShopVideo<br/>
   * 支持版本：android >= 6.3.2 ios >= 6.3.0<br/>
   * 对接人： baiyunpeng
   * @method ksBridge.reUploadShopVideo
   * @category Merchant
   * @version >=1.0.14
   * @example ./apis/merchant/reUploadShopVideo.demo
   * @demo merchant/reUploadShopVideo
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | uploadId | String | uploadShopVideo 方法返回的 uploadId | X | uploadId与filePath至少填写1个，如果都有优先使用filePath |
   * | filePath | String | uploadShopVideo 方法返回的 filePath | X | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   * 
   * 返回参数：
   * 与**uploadShopVideo**一样，详见**uploadShopVideo**
   */
  reUploadShopVideo: {
    optHandle: function optHandle(opt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assignOptions */])(opt, {
        notPromise: true,
        notDelete: true
      });
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 快手电商定制化分享<br />
   * 对应native接口：merchantShare<br/>
   * 支持版本：android >= 6.5.3 ios >= 6.5.6<br/>
   * 对接人： baiyunpeng
   * @method ksBridge.merchantShare
   * @category Merchant
   * @version >=1.0.14
   * @example ./apis/merchant/merchantShare.demo
   * @demo merchant/merchantShare
   * @description
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | param | Object | 分享设置，具体可查看示例代码 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * ```
   * {
   *     // 1: 正常; 0: 取消; 其他: 失败/异常
   *     result: 1
   * }
   * ```
   */
  merchantShare: true
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取某个会话在私信是否处于置顶状态<br/>
   * 对应native接口：querySessionIsStickyOnTop<br/>
   * 对接人：chenjihong<br/>
   * @method ksBridge.querySessionIsStickyOnTop
   * @category Merchant
   * @version >=1.0.15
   * @example ./apis/merchant/querySessionIsStickyOnTop.demo
   * @demo merchant/querySessionIsStickyOnTop
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | threadId | String | 会话ID | √ | - |
   * | type | Number | 聊天类型，目前仅支持0(单聊)和4(群聊) | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  querySessionIsStickyOnTop: true
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 对指定会话进行置顶/取消置顶操作<br/>
   * 对应native接口：reqSessionStickyOnTopWithThread<br/>
   * 对接人：chenjihong<br/>
   * @method ksBridge.reqSessionStickyOnTopWithThread
   * @category Merchant
   * @version >=1.0.15
   * @example ./apis/merchant/reqSessionStickyOnTopWithThread.demo
   * @demo merchant/reqSessionStickyOnTopWithThread
   * @description 
   * 
   * 调用参数：
   * 
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | threadId | String | 会话ID | √ | - |
   * | type | Number | 聊天类型，目前仅支持0(单聊)和4(群聊) | √ | - |
   * | stickyOnTop | Boolean | 是否置顶， true: 置顶，false: 取消置顶 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   **/
  reqSessionStickyOnTopWithThread: true
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获取Token<br />
   * 对应native接口：getSidToken<br/>
   * 对接人： chenjihong
   * @method ksBridge.getSidToken
   * @category Merchant
   * @version >=1.0.18
   * @example ./apis/merchant/getSidToken.demo
   * @demo merchant/getSidToken
   * @description
   * 
   * 注意：
   * 
   * 如果业务方的H5的域名是kuaishou.com\kwaishop.com\kwaixiaodian.com 3个域名 无需申请直接用
   * 如果不是上面的3个域名，就需要找安全的 @liaoxinxi @huanghao 评估是否有xss注入风险后才能使用
   * 
   * 调用参数：
   *
   * | 参数 | 类型 | 描述 | 必选 | 注明 |
   * | :--: | :--: | :--: | :--: | :--: |
   * | sid | String | 现在只支持 kuaishou.shop.im | √ | - |
   * | forceRefresh | Bool | 是true, 则会发起网络请求最新的token；是false，则获取本地，如果本地为空，再去请求网络。 | √ | - |
   * | success | Function | 成功回调函数 | X | - |
   * | fail | Function | 失败回调函数 | X | - |
   * | complete | Function | 回调函数，默认都会执行 | X | - |
   *
   * 返回参数：
   * 如果传入的sid 参数不是 kuaishou.shop.im , 则返回401的错误码。如果是后端返回，则返回后端的错误码；如果是未知，则返回412 未知错误码
   * 如果传入的sid 为kuaishou.shop.im， 则返回   { "result":1 , "token" :"xxxxx"，"ssecurity" : "xxxxx"}
   * 
   */
  getSidToken: true
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extend__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__URLSearchParam__ = __webpack_require__(143);




function request(config) {
  var defaultConfig = {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    timeout: 30000,
    withCredentials: true,
    transformRequest: [function (data, headers) {
      normalizeHeaderName(headers, 'Accept');
      normalizeHeaderName(headers, 'Content-Type');

      if (Object(__WEBPACK_IMPORTED_MODULE_0__index__["k" /* isObject */])(data)) {
        if (headers['Content-Type'] && headers['Content-Type'].indexOf('application/x-www-form-urlencoded') > -1) {
          var params = new __WEBPACK_IMPORTED_MODULE_3__URLSearchParam__["a" /* default */]();
          Object.keys(data).forEach(function (key) {
            params.append(key, data[key]);
          });
          return params.toString();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_2__stringify__["a" /* default */])(data);
      }

      return data;
    }],
    transformResponse: [function (data) {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          /* Ignore */
        }
      }

      return data;
    }]
  };
  config = Object(__WEBPACK_IMPORTED_MODULE_1__extend__["a" /* default */])(true, {}, defaultConfig, config);
  var promise = new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var data = transformData(config.data, config.headers, config.transformRequest);
    var _config = config,
        method = _config.method,
        _config$timeout = _config.timeout,
        timeout = _config$timeout === void 0 ? defaultConfig.timeout : _config$timeout,
        _config$withCredentia = _config.withCredentials,
        withCredentials = _config$withCredentia === void 0 ? defaultConfig.withCredentials : _config$withCredentia,
        responseType = _config.responseType;
    var url = config.url;

    if (method.toLowerCase() === 'get') {
      // get 请求参数不支持嵌套对象
      url = buildURL(url, data);
    }

    xhr.timeout = timeout;
    xhr.open(method.toUpperCase(), url, true);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        var _headers = parseHeaders(xhr.getAllResponseHeaders());

        var responseData = !responseType || responseType === 'text' ? xhr.responseText : xhr.response;
        var response = {
          result: 1,
          data: transformData(responseData, _headers, config.transformResponse),
          statusCode: xhr.status,
          headers: _headers
        };
        (xhr.status >= 200 && xhr.status < 300 ? resolve : reject)(response);
        xhr = null;
      }
    };

    xhr.onerror = function (err) {
      reject(err);
    };

    var headers = config.headers;
    Object.keys(headers).forEach(function (headerKey) {
      var headerVal = headers[headerKey];

      if ((!data || Object(__WEBPACK_IMPORTED_MODULE_0__index__["h" /* isBlob */])(data) || Object(__WEBPACK_IMPORTED_MODULE_0__index__["i" /* isFile */])(data)) && headerKey.toLowerCase() === 'content-type') {
        delete headers[headerKey];
      } else {
        xhr.setRequestHeader(headerKey, headerVal);
      }
    });

    if (withCredentials) {
      xhr.withCredentials = true;
    }

    if (responseType) {
      try {
        xhr.responseType = responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    xhr.send(data);
  });
  return promise;
}

function normalizeHeaderName(headers, normalizedName) {
  Object.keys(headers).forEach(function (headerName) {
    if (headerName !== normalizedName && headerName.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = headers[headerName];
      delete headers[headerName];
    }
  });
}

function parseHeaders(headers) {
  var parsed = {};

  if (headers) {
    headers.split('\n').forEach(function (headerStr) {
      var headerArr = headerStr.split(':');
      var headerKey = (headerArr[0] || '').trim().toLowerCase();
      var headerVal = (headerArr[1] || '').trim();

      if (headerKey) {
        parsed[headerKey] = headerVal;
      }
    });
  }

  return parsed;
}

function transformData(data, headers, fns) {
  fns.forEach(function (fn) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__index__["j" /* isFunction */])(fn)) {
      data = fn(data, headers);
    }
  });
  return data;
}

function buildURL(url, params) {
  if (!params || !Object(__WEBPACK_IMPORTED_MODULE_0__index__["k" /* isObject */])(params)) {
    return url;
  }

  var _params = new __WEBPACK_IMPORTED_MODULE_3__URLSearchParam__["a" /* default */]();

  Object.keys(params).forEach(function (key) {
    _params.append(key, params[key]);
  });

  var serializedParams = _params.toString();

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return URLSearchParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var URLSearchParams = /*#__PURE__*/function () {
  function URLSearchParams(search) {
    _classCallCheck(this, URLSearchParams);

    var dict = {};

    if (typeof search === 'string') {
      var searchIndex = search.indexOf('?');
      search = searchIndex > -1 ? search.slice(searchIndex + 1) : search;
      var pairs = search.split('&');
      var length = pairs.length;

      for (var i = 0; i < length; i++) {
        var value = pairs[i];
        var index = value.indexOf('=');

        if (-1 < index) {
          appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
        } else if (value.length) {
          appendTo(dict, decode(value), '');
        }
      }
    }

    this.dict = dict;
  }

  _createClass(URLSearchParams, [{
    key: "append",
    value: function append(key, value) {
      appendTo(this.dict, key, value);
    }
  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      var query = [];
      Object.keys(this.dict).sort().forEach(function (key) {
        var encoded = encode(key);
        var value = _this.dict[key];

        for (var i = 0; i < value.length; i++) {
          query.push(encoded + '=' + encode(value[i]));
        }
      });
      return query.join('&');
    }
  }]);

  return URLSearchParams;
}();



function appendTo(dict, key, value) {
  var res = Object(__WEBPACK_IMPORTED_MODULE_0__index__["g" /* isArray */])(value) ? value.join(',') : value;

  if (key in dict) {
    dict[key].push(res);
  } else {
    dict[key] = [res];
  }
}

function decode(str) {
  var findPercentSign = /%(?![0-9a-fA-F]{2})/g;
  return decodeURIComponent(str.replace(findPercentSign, '%25').replace(/\+/g, ' '));
}

function replacer(match) {
  var replace = {
    '!': '%21',
    '\'': '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return replace[match];
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendEventLog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function getUAInfo(key) {
  var ua = navigator.userAgent;
  var uaList = {};
  ua.split(' ').forEach(function (item) {
    var arr = item.split('/');
    uaList[arr[0]] = arr[1];
  });
  return uaList[key] ? uaList[key] : uaList;
}

function getWebViewType() {
  var ua = navigator.userAgent;

  if (ua.indexOf('Android') !== -1) {
    return 'WebView';
  }

  if (ua.indexOf('iPhone') !== -1) {
    var uaList = getUAInfo();

    if (uaList.Yoda && uaList.WebViewType === 'WK') {
      return 'YodaWKWebView';
    }

    if (!uaList.Yoda && uaList.WebView === 'WKWebView') {
      return 'WKWebView';
    }

    return 'UIWebView';
  }

  return '';
}

function sendEventLog(radarProjectId, data, startTime) {
  var duration = new Date().getTime() - startTime;

  if (__WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.isInYoda) {
    __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.tool.canIUse({
      namespace: 'tool',
      name: 'sendRadarLog'
    }, function (_ref) {
      var result = _ref.result,
          canUse = _ref.canUse;

      if (result === 1 && canUse) {
        __WEBPACK_IMPORTED_MODULE_0__ks_yoda_js_sdk___default.a.tool.sendRadarLog({
          removeStashedLog: [],
          sendImmediate: true,
          customData: {
            project_id: radarProjectId,
            data: [{
              key: 'event',
              value: {
                duration: startTime && duration
              },
              dimension: _objectSpread({
                yoda_version: getUAInfo('Yoda') || '',
                webview_type: getWebViewType()
              }, data)
            }]
          }
        });
      }
    });
  }
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(146),
      utf8 = __webpack_require__(8).utf8,
      isBuffer = __webpack_require__(147),
      bin = __webpack_require__(8).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 146 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ })
/******/ ]);
});
